"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Cattle Breeding Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.27
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CowHeatApiFp = exports.CowHeatApiAxiosParamCreator = exports.CattleSummariesApi = exports.CattleSummariesApiFactory = exports.CattleSummariesApiFp = exports.CattleSummariesApiAxiosParamCreator = exports.CattleHeatApi = exports.CattleHeatApiFactory = exports.CattleHeatApiFp = exports.CattleHeatApiAxiosParamCreator = exports.CattleBreedingHealthCheckApi = exports.CattleBreedingHealthCheckApiFactory = exports.CattleBreedingHealthCheckApiFp = exports.CattleBreedingHealthCheckApiAxiosParamCreator = exports.CattleBreedingApi = exports.CattleBreedingApiFactory = exports.CattleBreedingApiFp = exports.CattleBreedingApiAxiosParamCreator = exports.CalvingApi = exports.CalvingApiFactory = exports.CalvingApiFp = exports.CalvingApiAxiosParamCreator = exports.SeasonUpdateEventTypeEnum = exports.SeasonMetricsGroupEnum = exports.SeasonMetricTypeEnum = exports.PregnancyTestResultStatusEnum = exports.PregnancyStatusReasonEnum = exports.PregnancyStatusEnum = exports.PregnancyReturnedStatusEnum = exports.MatingKPIWarningTypeEnum = exports.ICowABUpdateTypeEnum = exports.DateSourceEnum = exports.CowSeasonSourceEnum = exports.CowPregnancyTestResultUpdateTypeEnum = exports.CowPregnancyTestResultTypeEnum = exports.CowPregnancyStatusUpdateTypeEnum = exports.CowPregnancyDiagnosisSourceEnum = exports.CowHeatEventUpdateTypeEnum = exports.CowHeatEventSymptomsEnum = exports.CowHeatEventStatusEnum = exports.CowHeatEventSourceEnum = exports.CowHeatEventInseminationResultStatusEnum = exports.ConceptionProbabilityLevelEnum = exports.CattleMatingTypeEnum = exports.CattleBreedingEventUpdateTypeEnum = exports.CattleBreedingEventTypeEnum = exports.CalvingUpdateTypeEnum = exports.CalvingStatusEnum = exports.CalvingRecoveryStateEnum = exports.ActivityPeakPredictionConfidenceEnum = void 0;
exports.SeasonApi = exports.SeasonApiFactory = exports.SeasonApiFp = exports.SeasonApiAxiosParamCreator = exports.PregnancyApi = exports.PregnancyApiFactory = exports.PregnancyApiFp = exports.PregnancyApiAxiosParamCreator = exports.DataApi = exports.DataApiFactory = exports.DataApiFp = exports.DataApiAxiosParamCreator = exports.CowHeatApi = exports.CowHeatApiFactory = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.ActivityPeakPredictionConfidenceEnum = {
    HIGH: 'HIGH',
    LOW: 'LOW'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CalvingRecoveryStateEnum = {
    WELL: 'WELL',
    POORLY: 'POORLY'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CalvingStatusEnum = {
    IN_CALF: 'IN_CALF',
    CALVED: 'CALVED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CalvingUpdateTypeEnum = {
    CREATED: 'CREATED',
    ATTRIBUTE_UPDATE: 'ATTRIBUTE_UPDATE',
    REMOVED: 'REMOVED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CattleBreedingEventTypeEnum = {
    VET_DIAGNOSIS: 'VET_DIAGNOSIS',
    MATING: 'MATING',
    CALVING: 'CALVING',
    HEAT: 'HEAT'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CattleBreedingEventUpdateTypeEnum = {
    CREATED: 'CREATED',
    UPDATED: 'UPDATED',
    DELETED: 'DELETED'
};
/**
 * How the cow was mated (ARTIFICIAL_INSEMINATION for artificial mating; BULL for natural mating)
 * @export
 * @enum {string}
 */
exports.CattleMatingTypeEnum = {
    ARTIFICAL_INSEMINATION: 'ARTIFICAL_INSEMINATION',
    BULL: 'BULL'
};
/**
 * Description of the relative level of the conception probability at the time of the alert
 * @export
 * @enum {string}
 */
exports.ConceptionProbabilityLevelEnum = {
    HIGH: 'HIGH',
    MEDIUM: 'MEDIUM',
    LOW: 'LOW'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CowHeatEventInseminationResultStatusEnum = {
    UNKNOWN: 'UNKNOWN',
    IN_CALF: 'IN_CALF',
    RETURNED: 'RETURNED'
};
/**
 * How the heat was added (by the system or manually by farmer)
 * @export
 * @enum {string}
 */
exports.CowHeatEventSourceEnum = {
    SYSTEM: 'SYSTEM',
    MANUAL: 'MANUAL',
    MANUAL_THEN_SYSTEM: 'MANUAL_THEN_SYSTEM'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CowHeatEventStatusEnum = {
    DETECTED: 'DETECTED',
    ON_HEAT: 'ON_HEAT',
    NOT_ON_HEAT: 'NOT_ON_HEAT'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CowHeatEventSymptomsEnum = {
    REDUCED_GRAZING: 'REDUCED_GRAZING',
    INCREASED_ACTIVITY: 'INCREASED_ACTIVITY',
    RETAINING_MILK: 'RETAINING_MILK',
    STANDING_HEAT: 'STANDING_HEAT',
    GROUPS_WITH_SAG_COWS: 'GROUPS_WITH_SAG_COWS',
    VULVA_SIGNS: 'VULVA_SIGNS',
    ARCHED_BACK: 'ARCHED_BACK',
    EXCITABLE: 'EXCITABLE',
    RIDING_OTHERS: 'RIDING_OTHERS',
    RUBBED_PAINT: 'RUBBED_PAINT'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CowHeatEventUpdateTypeEnum = {
    CREATED: 'Created',
    ATTRIBUTE_UPDATE: 'AttributeUpdate',
    REMOVED: 'Removed'
};
/**
 * Origin of the pregnancy diagnosis
 * @export
 * @enum {string}
 */
exports.CowPregnancyDiagnosisSourceEnum = {
    MINDA: 'MINDA',
    OTHER: 'OTHER'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CowPregnancyStatusUpdateTypeEnum = {
    CREATED: 'Created',
    UPDATED: 'Updated',
    REMOVED: 'Removed'
};
/**
 * The result of the pregnancy test
 * @export
 * @enum {string}
 */
exports.CowPregnancyTestResultTypeEnum = {
    POSITIVE: 'POSITIVE',
    NEGATIVE: 'NEGATIVE',
    DOUBTFUL: 'DOUBTFUL'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CowPregnancyTestResultUpdateTypeEnum = {
    CREATED: 'Created',
    UPDATED: 'Updated',
    REMOVED: 'Removed'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CowSeasonSourceEnum = {
    MANUAL: 'MANUAL',
    AUTOMATIC: 'AUTOMATIC'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DateSourceEnum = {
    MINDA: 'MINDA',
    HALTER: 'HALTER',
    CRV: 'CRV',
    OTHER: 'OTHER'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ICowABUpdateTypeEnum = {
    CREATED: 'CREATED',
    UPDATED: 'UPDATED',
    DELETED: 'DELETED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.MatingKPIWarningTypeEnum = {
    NONE: 'NONE',
    SLOW_TO_CYCLE: 'SLOW_TO_CYCLE',
    LOW_CYCLING_RATE: 'LOW_CYCLING_RATE',
    LOW_SUBMISSION_RATE: 'LOW_SUBMISSION_RATE',
    LOW_NON_RETURN_RATE: 'LOW_NON_RETURN_RATE'
};
/**
 * Combination of cycling and mating information to help determine the reason for the pregnancy status. Default is NOT_MATED
 * @export
 * @enum {string}
 */
exports.PregnancyReturnedStatusEnum = {
    NOT_MATED: 'NOT_MATED',
    MATED_RECENTLY: 'MATED_RECENTLY',
    RETURNED: 'RETURNED',
    NON_RETURNED: 'NON_RETURNED'
};
/**
 * Whether we think a cow is pregnant or not. Default is PENDING
 * @export
 * @enum {string}
 */
exports.PregnancyStatusEnum = {
    IN_CALF: 'IN_CALF',
    NOT_IN_CALF: 'NOT_IN_CALF',
    PENDING: 'PENDING'
};
/**
 * The reason behind whether we think that the cow is pregnant. Default is NOT_MATED
 * @export
 * @enum {string}
 */
exports.PregnancyStatusReasonEnum = {
    DIAGNOSED_POSITIVE: 'DIAGNOSED_POSITIVE',
    DIAGNOSED_NEGATIVE: 'DIAGNOSED_NEGATIVE',
    NOT_MATED: 'NOT_MATED',
    MATED_RECENTLY: 'MATED_RECENTLY',
    RETURNED: 'RETURNED',
    NON_RETURNED: 'NON_RETURNED'
};
/**
 * The result of the pregnancy test if there has been a pregnancy test. Default is NO_PREG_TEST
 * @export
 * @enum {string}
 */
exports.PregnancyTestResultStatusEnum = {
    IN_CALF: 'IN_CALF',
    NOT_IN_CALF: 'NOT_IN_CALF',
    DOUBTFUL: 'DOUBTFUL',
    NO_PREG_TEST: 'NO_PREG_TEST'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SeasonMetricTypeEnum = {
    CYCLING_RATE: 'CYCLING_RATE',
    SUBMISSION_RATE: 'SUBMISSION_RATE',
    AVERAGE_DAYS_TO_FIRST_HEAT: 'AVERAGE_DAYS_TO_FIRST_HEAT',
    NON_RETURN_RATE: 'NON_RETURN_RATE',
    ESTIMATED_IN_CALF_RATE: 'ESTIMATED_IN_CALF_RATE',
    FORECAST_CYCLED_RATE: 'FORECAST_CYCLED_RATE',
    FORECAST_CYCLING_RATE: 'FORECAST_CYCLING_RATE',
    FORECAST_SUBMISSION_RATE: 'FORECAST_SUBMISSION_RATE',
    FORECAST_IN_CALF_RATE: 'FORECAST_IN_CALF_RATE',
    CALVED_42_DAYS_AGO_AND_CYCLED: 'CALVED_42_DAYS_AGO_AND_CYCLED'
};
/**
 * Groupings used to provide a high level summary of season mating performance
 * @export
 * @enum {string}
 */
exports.SeasonMetricsGroupEnum = {
    NON_CYCLING: 'NON_CYCLING',
    CYCLING: 'CYCLING',
    SUBMITTED: 'SUBMITTED',
    NOT_SUBMITTED: 'NOT_SUBMITTED',
    NON_RETURNED: 'NON_RETURNED',
    RETURNED: 'RETURNED',
    ELIGIBLE_NON_RETURNED: 'ELIGIBLE_NON_RETURNED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SeasonUpdateEventTypeEnum = {
    CREATED: 'CREATED',
    UPDATED: 'UPDATED',
    DELETED: 'DELETED'
};
/**
 * CalvingApi - axios parameter creator
 * @export
 */
var CalvingApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a calving
         * @param {ICreateCalvingDTO} iCreateCalvingDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalving: function (iCreateCalvingDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'iCreateCalvingDTO' is not null or undefined
                    (0, common_1.assertParamExists)('createCalving', 'iCreateCalvingDTO', iCreateCalvingDTO);
                    localVarPath = "/cattle-breeding/calving";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateCalvingDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Post expected calving date for a cow
         * @param {ICreateExpectedCalvingDTO} iCreateExpectedCalvingDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExpectedCalving: function (iCreateExpectedCalvingDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'iCreateExpectedCalvingDTO' is not null or undefined
                    (0, common_1.assertParamExists)('createExpectedCalving', 'iCreateExpectedCalvingDTO', iCreateExpectedCalvingDTO);
                    localVarPath = "/cattle-breeding/calving/expected";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateExpectedCalvingDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Create calvings from a list of cattleIds
         * @param {ICreateManyCalvingsDTO} iCreateManyCalvingsDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyCalvings: function (iCreateManyCalvingsDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'iCreateManyCalvingsDTO' is not null or undefined
                    (0, common_1.assertParamExists)('createManyCalvings', 'iCreateManyCalvingsDTO', iCreateManyCalvingsDTO);
                    localVarPath = "/cattle-breeding/calving/many";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateManyCalvingsDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete an existing calving
         * @param {string} calvingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalving: function (calvingId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'calvingId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteCalving', 'calvingId', calvingId);
                    localVarPath = "/cattle-breeding/calving/{calvingId}"
                        .replace("{".concat("calvingId", "}"), encodeURIComponent(String(calvingId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Find cattle calvings
         * @param {string} [cattleId]
         * @param {CalvingStatusEnum} [status]
         * @param {CalvingRecoveryStateEnum} [calvingRecoveryState] If not provided, returns calved cows of all recovery states. If RECOVERING_WELL, returns those with no recovery state and RECOVERING_WELL. RECOVERING_POORLY only returns RECOVERING_POORLY
         * @param {Date} [calvedAtAfter] Defaults to six months ago unless other date provided
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCalvings: function (cattleId, status, calvingRecoveryState, calvedAtAfter, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cattle-breeding/calving/find";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (cattleId !== undefined) {
                        localVarQueryParameter['cattleId'] = cattleId;
                    }
                    if (status !== undefined) {
                        localVarQueryParameter['status'] = status;
                    }
                    if (calvingRecoveryState !== undefined) {
                        localVarQueryParameter['calvingRecoveryState'] = calvingRecoveryState;
                    }
                    if (calvedAtAfter !== undefined) {
                        localVarQueryParameter['calvedAtAfter'] = (calvedAtAfter instanceof Date) ?
                            calvedAtAfter.toISOString() :
                            calvedAtAfter;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Find count of cows in calving
         * @param {Date} [from] Start date to query from.
         * @param {Date} [to] End date to query to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalvingSummary: function (from, to, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cattle-breeding/calving/summary";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (from !== undefined) {
                        localVarQueryParameter['from'] = (from instanceof Date) ?
                            from.toISOString() :
                            from;
                    }
                    if (to !== undefined) {
                        localVarQueryParameter['to'] = (to instanceof Date) ?
                            to.toISOString() :
                            to;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update calvings as calved
         * @param {IMarkCowsAsCalvedRequestDTO} [iMarkCowsAsCalvedRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsCalved: function (iMarkCowsAsCalvedRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cattle-breeding/calving/mark-as-calved";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iMarkCowsAsCalvedRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Edit the calved at date of an existing calving
         * @param {string} calvingId
         * @param {IUpdateCalvingRequestDTO} iUpdateCalvingRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalvedAt: function (calvingId, iUpdateCalvingRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'calvingId' is not null or undefined
                    (0, common_1.assertParamExists)('updateCalvedAt', 'calvingId', calvingId);
                    // verify required parameter 'iUpdateCalvingRequestDTO' is not null or undefined
                    (0, common_1.assertParamExists)('updateCalvedAt', 'iUpdateCalvingRequestDTO', iUpdateCalvingRequestDTO);
                    localVarPath = "/cattle-breeding/calving/{calvingId}/calved-at"
                        .replace("{".concat("calvingId", "}"), encodeURIComponent(String(calvingId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateCalvingRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Edit the expected calving date of an existing calving
         * @param {string} calvingId
         * @param {IUpdateExpectedCalvingRequestDTO} iUpdateExpectedCalvingRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExpectedCalvingDate: function (calvingId, iUpdateExpectedCalvingRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'calvingId' is not null or undefined
                    (0, common_1.assertParamExists)('updateExpectedCalvingDate', 'calvingId', calvingId);
                    // verify required parameter 'iUpdateExpectedCalvingRequestDTO' is not null or undefined
                    (0, common_1.assertParamExists)('updateExpectedCalvingDate', 'iUpdateExpectedCalvingRequestDTO', iUpdateExpectedCalvingRequestDTO);
                    localVarPath = "/cattle-breeding/calving/{calvingId}/expected-calving-date"
                        .replace("{".concat("calvingId", "}"), encodeURIComponent(String(calvingId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateExpectedCalvingRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CalvingApiAxiosParamCreator = CalvingApiAxiosParamCreator;
/**
 * CalvingApi - functional programming interface
 * @export
 */
var CalvingApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CalvingApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a calving
         * @param {ICreateCalvingDTO} iCreateCalvingDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalving: function (iCreateCalvingDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createCalving(iCreateCalvingDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Post expected calving date for a cow
         * @param {ICreateExpectedCalvingDTO} iCreateExpectedCalvingDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExpectedCalving: function (iCreateExpectedCalvingDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createExpectedCalving(iCreateExpectedCalvingDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create calvings from a list of cattleIds
         * @param {ICreateManyCalvingsDTO} iCreateManyCalvingsDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyCalvings: function (iCreateManyCalvingsDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createManyCalvings(iCreateManyCalvingsDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete an existing calving
         * @param {string} calvingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalving: function (calvingId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteCalving(calvingId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Find cattle calvings
         * @param {string} [cattleId]
         * @param {CalvingStatusEnum} [status]
         * @param {CalvingRecoveryStateEnum} [calvingRecoveryState] If not provided, returns calved cows of all recovery states. If RECOVERING_WELL, returns those with no recovery state and RECOVERING_WELL. RECOVERING_POORLY only returns RECOVERING_POORLY
         * @param {Date} [calvedAtAfter] Defaults to six months ago unless other date provided
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCalvings: function (cattleId, status, calvingRecoveryState, calvedAtAfter, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findCalvings(cattleId, status, calvingRecoveryState, calvedAtAfter, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Find count of cows in calving
         * @param {Date} [from] Start date to query from.
         * @param {Date} [to] End date to query to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalvingSummary: function (from, to, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCalvingSummary(from, to, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update calvings as calved
         * @param {IMarkCowsAsCalvedRequestDTO} [iMarkCowsAsCalvedRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsCalved: function (iMarkCowsAsCalvedRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.markAsCalved(iMarkCowsAsCalvedRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Edit the calved at date of an existing calving
         * @param {string} calvingId
         * @param {IUpdateCalvingRequestDTO} iUpdateCalvingRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalvedAt: function (calvingId, iUpdateCalvingRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCalvedAt(calvingId, iUpdateCalvingRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Edit the expected calving date of an existing calving
         * @param {string} calvingId
         * @param {IUpdateExpectedCalvingRequestDTO} iUpdateExpectedCalvingRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExpectedCalvingDate: function (calvingId, iUpdateExpectedCalvingRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateExpectedCalvingDate(calvingId, iUpdateExpectedCalvingRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CalvingApiFp = CalvingApiFp;
/**
 * CalvingApi - factory interface
 * @export
 */
var CalvingApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CalvingApiFp)(configuration);
    return {
        /**
         * Create a calving
         * @param {ICreateCalvingDTO} iCreateCalvingDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalving: function (iCreateCalvingDTO, options) {
            return localVarFp.createCalving(iCreateCalvingDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Post expected calving date for a cow
         * @param {ICreateExpectedCalvingDTO} iCreateExpectedCalvingDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExpectedCalving: function (iCreateExpectedCalvingDTO, options) {
            return localVarFp.createExpectedCalving(iCreateExpectedCalvingDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create calvings from a list of cattleIds
         * @param {ICreateManyCalvingsDTO} iCreateManyCalvingsDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyCalvings: function (iCreateManyCalvingsDTO, options) {
            return localVarFp.createManyCalvings(iCreateManyCalvingsDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete an existing calving
         * @param {string} calvingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalving: function (calvingId, options) {
            return localVarFp.deleteCalving(calvingId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Find cattle calvings
         * @param {string} [cattleId]
         * @param {CalvingStatusEnum} [status]
         * @param {CalvingRecoveryStateEnum} [calvingRecoveryState] If not provided, returns calved cows of all recovery states. If RECOVERING_WELL, returns those with no recovery state and RECOVERING_WELL. RECOVERING_POORLY only returns RECOVERING_POORLY
         * @param {Date} [calvedAtAfter] Defaults to six months ago unless other date provided
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCalvings: function (cattleId, status, calvingRecoveryState, calvedAtAfter, options) {
            return localVarFp.findCalvings(cattleId, status, calvingRecoveryState, calvedAtAfter, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Find count of cows in calving
         * @param {Date} [from] Start date to query from.
         * @param {Date} [to] End date to query to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalvingSummary: function (from, to, options) {
            return localVarFp.getCalvingSummary(from, to, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update calvings as calved
         * @param {IMarkCowsAsCalvedRequestDTO} [iMarkCowsAsCalvedRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsCalved: function (iMarkCowsAsCalvedRequestDTO, options) {
            return localVarFp.markAsCalved(iMarkCowsAsCalvedRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Edit the calved at date of an existing calving
         * @param {string} calvingId
         * @param {IUpdateCalvingRequestDTO} iUpdateCalvingRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalvedAt: function (calvingId, iUpdateCalvingRequestDTO, options) {
            return localVarFp.updateCalvedAt(calvingId, iUpdateCalvingRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Edit the expected calving date of an existing calving
         * @param {string} calvingId
         * @param {IUpdateExpectedCalvingRequestDTO} iUpdateExpectedCalvingRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExpectedCalvingDate: function (calvingId, iUpdateExpectedCalvingRequestDTO, options) {
            return localVarFp.updateExpectedCalvingDate(calvingId, iUpdateExpectedCalvingRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CalvingApiFactory = CalvingApiFactory;
/**
 * CalvingApi - object-oriented interface
 * @export
 * @class CalvingApi
 * @extends {BaseAPI}
 */
var CalvingApi = /** @class */ (function (_super) {
    __extends(CalvingApi, _super);
    function CalvingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a calving
     * @param {ICreateCalvingDTO} iCreateCalvingDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalvingApi
     */
    CalvingApi.prototype.createCalving = function (iCreateCalvingDTO, options) {
        var _this = this;
        return (0, exports.CalvingApiFp)(this.configuration).createCalving(iCreateCalvingDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Post expected calving date for a cow
     * @param {ICreateExpectedCalvingDTO} iCreateExpectedCalvingDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalvingApi
     */
    CalvingApi.prototype.createExpectedCalving = function (iCreateExpectedCalvingDTO, options) {
        var _this = this;
        return (0, exports.CalvingApiFp)(this.configuration).createExpectedCalving(iCreateExpectedCalvingDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create calvings from a list of cattleIds
     * @param {ICreateManyCalvingsDTO} iCreateManyCalvingsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalvingApi
     */
    CalvingApi.prototype.createManyCalvings = function (iCreateManyCalvingsDTO, options) {
        var _this = this;
        return (0, exports.CalvingApiFp)(this.configuration).createManyCalvings(iCreateManyCalvingsDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete an existing calving
     * @param {string} calvingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalvingApi
     */
    CalvingApi.prototype.deleteCalving = function (calvingId, options) {
        var _this = this;
        return (0, exports.CalvingApiFp)(this.configuration).deleteCalving(calvingId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Find cattle calvings
     * @param {string} [cattleId]
     * @param {CalvingStatusEnum} [status]
     * @param {CalvingRecoveryStateEnum} [calvingRecoveryState] If not provided, returns calved cows of all recovery states. If RECOVERING_WELL, returns those with no recovery state and RECOVERING_WELL. RECOVERING_POORLY only returns RECOVERING_POORLY
     * @param {Date} [calvedAtAfter] Defaults to six months ago unless other date provided
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalvingApi
     */
    CalvingApi.prototype.findCalvings = function (cattleId, status, calvingRecoveryState, calvedAtAfter, options) {
        var _this = this;
        return (0, exports.CalvingApiFp)(this.configuration).findCalvings(cattleId, status, calvingRecoveryState, calvedAtAfter, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Find count of cows in calving
     * @param {Date} [from] Start date to query from.
     * @param {Date} [to] End date to query to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalvingApi
     */
    CalvingApi.prototype.getCalvingSummary = function (from, to, options) {
        var _this = this;
        return (0, exports.CalvingApiFp)(this.configuration).getCalvingSummary(from, to, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update calvings as calved
     * @param {IMarkCowsAsCalvedRequestDTO} [iMarkCowsAsCalvedRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalvingApi
     */
    CalvingApi.prototype.markAsCalved = function (iMarkCowsAsCalvedRequestDTO, options) {
        var _this = this;
        return (0, exports.CalvingApiFp)(this.configuration).markAsCalved(iMarkCowsAsCalvedRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Edit the calved at date of an existing calving
     * @param {string} calvingId
     * @param {IUpdateCalvingRequestDTO} iUpdateCalvingRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalvingApi
     */
    CalvingApi.prototype.updateCalvedAt = function (calvingId, iUpdateCalvingRequestDTO, options) {
        var _this = this;
        return (0, exports.CalvingApiFp)(this.configuration).updateCalvedAt(calvingId, iUpdateCalvingRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Edit the expected calving date of an existing calving
     * @param {string} calvingId
     * @param {IUpdateExpectedCalvingRequestDTO} iUpdateExpectedCalvingRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalvingApi
     */
    CalvingApi.prototype.updateExpectedCalvingDate = function (calvingId, iUpdateExpectedCalvingRequestDTO, options) {
        var _this = this;
        return (0, exports.CalvingApiFp)(this.configuration).updateExpectedCalvingDate(calvingId, iUpdateExpectedCalvingRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CalvingApi;
}(base_1.BaseAPI));
exports.CalvingApi = CalvingApi;
/**
 * CattleBreedingApi - axios parameter creator
 * @export
 */
var CattleBreedingApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns all cattle breeding data to be used by the heat model acceptance tests
         * @param {Array<string>} cattleIds The unique identifiers for the cattle to return data for
         * @param {Date} date The effective date to use when calculating the time range of data to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHeatAcceptanceTestData: function (cattleIds, date, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'cattleIds' is not null or undefined
                    (0, common_1.assertParamExists)('getHeatAcceptanceTestData', 'cattleIds', cattleIds);
                    // verify required parameter 'date' is not null or undefined
                    (0, common_1.assertParamExists)('getHeatAcceptanceTestData', 'date', date);
                    localVarPath = "/cattle-breeding/acceptance-test-data/heat-model";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (cattleIds) {
                        localVarQueryParameter['cattleIds'] = cattleIds;
                    }
                    if (date !== undefined) {
                        localVarQueryParameter['date'] = (date instanceof Date) ?
                            date.toISOString() :
                            date;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Endpoint to get breeding events for a specified season
         * @param {string} season The year the event happened in
         * @param {CattleBreedingEventTypeEnum} [eventType] The type of breeding event
         * @param {string} [eventId] Unique identifier for the event
         * @param {string} [cattleId] The unique identifier for the cattle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSeasonBreedingEvents: function (season, eventType, eventId, cattleId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'season' is not null or undefined
                    (0, common_1.assertParamExists)('getSeasonBreedingEvents', 'season', season);
                    localVarPath = "/cattle-breeding/{season}"
                        .replace("{".concat("season", "}"), encodeURIComponent(String(season)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (eventType !== undefined) {
                        localVarQueryParameter['eventType'] = eventType;
                    }
                    if (eventId !== undefined) {
                        localVarQueryParameter['eventId'] = eventId;
                    }
                    if (cattleId !== undefined) {
                        localVarQueryParameter['cattleId'] = cattleId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Save heat alert monitoring data
         * @param {IHeatAlertMonitoringData} iHeatAlertMonitoringData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveHeatAlertMonitoringData: function (iHeatAlertMonitoringData, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'iHeatAlertMonitoringData' is not null or undefined
                    (0, common_1.assertParamExists)('saveHeatAlertMonitoringData', 'iHeatAlertMonitoringData', iHeatAlertMonitoringData);
                    localVarPath = "/cattle-breeding/monitoring-data/heat-model";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iHeatAlertMonitoringData, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CattleBreedingApiAxiosParamCreator = CattleBreedingApiAxiosParamCreator;
/**
 * CattleBreedingApi - functional programming interface
 * @export
 */
var CattleBreedingApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CattleBreedingApiAxiosParamCreator)(configuration);
    return {
        /**
         * Returns all cattle breeding data to be used by the heat model acceptance tests
         * @param {Array<string>} cattleIds The unique identifiers for the cattle to return data for
         * @param {Date} date The effective date to use when calculating the time range of data to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHeatAcceptanceTestData: function (cattleIds, date, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getHeatAcceptanceTestData(cattleIds, date, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Endpoint to get breeding events for a specified season
         * @param {string} season The year the event happened in
         * @param {CattleBreedingEventTypeEnum} [eventType] The type of breeding event
         * @param {string} [eventId] Unique identifier for the event
         * @param {string} [cattleId] The unique identifier for the cattle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSeasonBreedingEvents: function (season, eventType, eventId, cattleId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSeasonBreedingEvents(season, eventType, eventId, cattleId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Save heat alert monitoring data
         * @param {IHeatAlertMonitoringData} iHeatAlertMonitoringData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveHeatAlertMonitoringData: function (iHeatAlertMonitoringData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.saveHeatAlertMonitoringData(iHeatAlertMonitoringData, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CattleBreedingApiFp = CattleBreedingApiFp;
/**
 * CattleBreedingApi - factory interface
 * @export
 */
var CattleBreedingApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CattleBreedingApiFp)(configuration);
    return {
        /**
         * Returns all cattle breeding data to be used by the heat model acceptance tests
         * @param {Array<string>} cattleIds The unique identifiers for the cattle to return data for
         * @param {Date} date The effective date to use when calculating the time range of data to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHeatAcceptanceTestData: function (cattleIds, date, options) {
            return localVarFp.getHeatAcceptanceTestData(cattleIds, date, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Endpoint to get breeding events for a specified season
         * @param {string} season The year the event happened in
         * @param {CattleBreedingEventTypeEnum} [eventType] The type of breeding event
         * @param {string} [eventId] Unique identifier for the event
         * @param {string} [cattleId] The unique identifier for the cattle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSeasonBreedingEvents: function (season, eventType, eventId, cattleId, options) {
            return localVarFp.getSeasonBreedingEvents(season, eventType, eventId, cattleId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Save heat alert monitoring data
         * @param {IHeatAlertMonitoringData} iHeatAlertMonitoringData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveHeatAlertMonitoringData: function (iHeatAlertMonitoringData, options) {
            return localVarFp.saveHeatAlertMonitoringData(iHeatAlertMonitoringData, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CattleBreedingApiFactory = CattleBreedingApiFactory;
/**
 * CattleBreedingApi - object-oriented interface
 * @export
 * @class CattleBreedingApi
 * @extends {BaseAPI}
 */
var CattleBreedingApi = /** @class */ (function (_super) {
    __extends(CattleBreedingApi, _super);
    function CattleBreedingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns all cattle breeding data to be used by the heat model acceptance tests
     * @param {Array<string>} cattleIds The unique identifiers for the cattle to return data for
     * @param {Date} date The effective date to use when calculating the time range of data to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CattleBreedingApi
     */
    CattleBreedingApi.prototype.getHeatAcceptanceTestData = function (cattleIds, date, options) {
        var _this = this;
        return (0, exports.CattleBreedingApiFp)(this.configuration).getHeatAcceptanceTestData(cattleIds, date, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Endpoint to get breeding events for a specified season
     * @param {string} season The year the event happened in
     * @param {CattleBreedingEventTypeEnum} [eventType] The type of breeding event
     * @param {string} [eventId] Unique identifier for the event
     * @param {string} [cattleId] The unique identifier for the cattle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CattleBreedingApi
     */
    CattleBreedingApi.prototype.getSeasonBreedingEvents = function (season, eventType, eventId, cattleId, options) {
        var _this = this;
        return (0, exports.CattleBreedingApiFp)(this.configuration).getSeasonBreedingEvents(season, eventType, eventId, cattleId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Save heat alert monitoring data
     * @param {IHeatAlertMonitoringData} iHeatAlertMonitoringData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CattleBreedingApi
     */
    CattleBreedingApi.prototype.saveHeatAlertMonitoringData = function (iHeatAlertMonitoringData, options) {
        var _this = this;
        return (0, exports.CattleBreedingApiFp)(this.configuration).saveHeatAlertMonitoringData(iHeatAlertMonitoringData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CattleBreedingApi;
}(base_1.BaseAPI));
exports.CattleBreedingApi = CattleBreedingApi;
/**
 * CattleBreedingHealthCheckApi - axios parameter creator
 * @export
 */
var CattleBreedingHealthCheckApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cattle-breeding/healthcheck";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CattleBreedingHealthCheckApiAxiosParamCreator = CattleBreedingHealthCheckApiAxiosParamCreator;
/**
 * CattleBreedingHealthCheckApi - functional programming interface
 * @export
 */
var CattleBreedingHealthCheckApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CattleBreedingHealthCheckApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.healthCheck(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CattleBreedingHealthCheckApiFp = CattleBreedingHealthCheckApiFp;
/**
 * CattleBreedingHealthCheckApi - factory interface
 * @export
 */
var CattleBreedingHealthCheckApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CattleBreedingHealthCheckApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck: function (options) {
            return localVarFp.healthCheck(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CattleBreedingHealthCheckApiFactory = CattleBreedingHealthCheckApiFactory;
/**
 * CattleBreedingHealthCheckApi - object-oriented interface
 * @export
 * @class CattleBreedingHealthCheckApi
 * @extends {BaseAPI}
 */
var CattleBreedingHealthCheckApi = /** @class */ (function (_super) {
    __extends(CattleBreedingHealthCheckApi, _super);
    function CattleBreedingHealthCheckApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CattleBreedingHealthCheckApi
     */
    CattleBreedingHealthCheckApi.prototype.healthCheck = function (options) {
        var _this = this;
        return (0, exports.CattleBreedingHealthCheckApiFp)(this.configuration).healthCheck(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CattleBreedingHealthCheckApi;
}(base_1.BaseAPI));
exports.CattleBreedingHealthCheckApi = CattleBreedingHealthCheckApi;
/**
 * CattleHeatApi - axios parameter creator
 * @export
 */
var CattleHeatApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Endpoint to create a heat event from array
         * @param {Array<ICreateHeatRequestDTO>} iCreateHeatRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCattleHeatEvents: function (iCreateHeatRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'iCreateHeatRequestDTO' is not null or undefined
                    (0, common_1.assertParamExists)('createCattleHeatEvents', 'iCreateHeatRequestDTO', iCreateHeatRequestDTO);
                    localVarPath = "/cattle-breeding/heat";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateHeatRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Endpoint to dismiss a heat event as correct or incorrect
         * @param {string} id
         * @param {IDismissCattleHeatRequestDTO} iDismissCattleHeatRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissCattleHeatEvent: function (id, iDismissCattleHeatRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('dismissCattleHeatEvent', 'id', id);
                    // verify required parameter 'iDismissCattleHeatRequestDTO' is not null or undefined
                    (0, common_1.assertParamExists)('dismissCattleHeatEvent', 'iDismissCattleHeatRequestDTO', iDismissCattleHeatRequestDTO);
                    localVarPath = "/cattle-breeding/heat/{id}/dismiss"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iDismissCattleHeatRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Endpoint to get heat events
         * @param {string} [filter] Apply filtering options to the request
         * @param {string} [sort] Apply sort options to the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCattleHeatEvents: function (filter, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cattle-breeding/heat";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (filter !== undefined) {
                        localVarQueryParameter['filter'] = filter;
                    }
                    if (sort !== undefined) {
                        localVarQueryParameter['sort'] = sort;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CattleHeatApiAxiosParamCreator = CattleHeatApiAxiosParamCreator;
/**
 * CattleHeatApi - functional programming interface
 * @export
 */
var CattleHeatApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CattleHeatApiAxiosParamCreator)(configuration);
    return {
        /**
         * Endpoint to create a heat event from array
         * @param {Array<ICreateHeatRequestDTO>} iCreateHeatRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCattleHeatEvents: function (iCreateHeatRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createCattleHeatEvents(iCreateHeatRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Endpoint to dismiss a heat event as correct or incorrect
         * @param {string} id
         * @param {IDismissCattleHeatRequestDTO} iDismissCattleHeatRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissCattleHeatEvent: function (id, iDismissCattleHeatRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.dismissCattleHeatEvent(id, iDismissCattleHeatRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Endpoint to get heat events
         * @param {string} [filter] Apply filtering options to the request
         * @param {string} [sort] Apply sort options to the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCattleHeatEvents: function (filter, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCattleHeatEvents(filter, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CattleHeatApiFp = CattleHeatApiFp;
/**
 * CattleHeatApi - factory interface
 * @export
 */
var CattleHeatApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CattleHeatApiFp)(configuration);
    return {
        /**
         * Endpoint to create a heat event from array
         * @param {Array<ICreateHeatRequestDTO>} iCreateHeatRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCattleHeatEvents: function (iCreateHeatRequestDTO, options) {
            return localVarFp.createCattleHeatEvents(iCreateHeatRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Endpoint to dismiss a heat event as correct or incorrect
         * @param {string} id
         * @param {IDismissCattleHeatRequestDTO} iDismissCattleHeatRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissCattleHeatEvent: function (id, iDismissCattleHeatRequestDTO, options) {
            return localVarFp.dismissCattleHeatEvent(id, iDismissCattleHeatRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Endpoint to get heat events
         * @param {string} [filter] Apply filtering options to the request
         * @param {string} [sort] Apply sort options to the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCattleHeatEvents: function (filter, sort, options) {
            return localVarFp.getCattleHeatEvents(filter, sort, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CattleHeatApiFactory = CattleHeatApiFactory;
/**
 * CattleHeatApi - object-oriented interface
 * @export
 * @class CattleHeatApi
 * @extends {BaseAPI}
 */
var CattleHeatApi = /** @class */ (function (_super) {
    __extends(CattleHeatApi, _super);
    function CattleHeatApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Endpoint to create a heat event from array
     * @param {Array<ICreateHeatRequestDTO>} iCreateHeatRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CattleHeatApi
     */
    CattleHeatApi.prototype.createCattleHeatEvents = function (iCreateHeatRequestDTO, options) {
        var _this = this;
        return (0, exports.CattleHeatApiFp)(this.configuration).createCattleHeatEvents(iCreateHeatRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Endpoint to dismiss a heat event as correct or incorrect
     * @param {string} id
     * @param {IDismissCattleHeatRequestDTO} iDismissCattleHeatRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CattleHeatApi
     */
    CattleHeatApi.prototype.dismissCattleHeatEvent = function (id, iDismissCattleHeatRequestDTO, options) {
        var _this = this;
        return (0, exports.CattleHeatApiFp)(this.configuration).dismissCattleHeatEvent(id, iDismissCattleHeatRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Endpoint to get heat events
     * @param {string} [filter] Apply filtering options to the request
     * @param {string} [sort] Apply sort options to the request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CattleHeatApi
     */
    CattleHeatApi.prototype.getCattleHeatEvents = function (filter, sort, options) {
        var _this = this;
        return (0, exports.CattleHeatApiFp)(this.configuration).getCattleHeatEvents(filter, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CattleHeatApi;
}(base_1.BaseAPI));
exports.CattleHeatApi = CattleHeatApi;
/**
 * CattleSummariesApi - axios parameter creator
 * @export
 */
var CattleSummariesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get all cattle summaries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCattleSummaries: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cattle-breeding/cattle-summaries";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CattleSummariesApiAxiosParamCreator = CattleSummariesApiAxiosParamCreator;
/**
 * CattleSummariesApi - functional programming interface
 * @export
 */
var CattleSummariesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CattleSummariesApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get all cattle summaries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCattleSummaries: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCattleSummaries(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CattleSummariesApiFp = CattleSummariesApiFp;
/**
 * CattleSummariesApi - factory interface
 * @export
 */
var CattleSummariesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CattleSummariesApiFp)(configuration);
    return {
        /**
         * Get all cattle summaries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCattleSummaries: function (options) {
            return localVarFp.getCattleSummaries(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CattleSummariesApiFactory = CattleSummariesApiFactory;
/**
 * CattleSummariesApi - object-oriented interface
 * @export
 * @class CattleSummariesApi
 * @extends {BaseAPI}
 */
var CattleSummariesApi = /** @class */ (function (_super) {
    __extends(CattleSummariesApi, _super);
    function CattleSummariesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get all cattle summaries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CattleSummariesApi
     */
    CattleSummariesApi.prototype.getCattleSummaries = function (options) {
        var _this = this;
        return (0, exports.CattleSummariesApiFp)(this.configuration).getCattleSummaries(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CattleSummariesApi;
}(base_1.BaseAPI));
exports.CattleSummariesApi = CattleSummariesApi;
/**
 * CowHeatApi - axios parameter creator
 * @export
 */
var CowHeatApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Find heat scores for a cow within an optional time range
         * @param {string} cattleId
         * @param {Date} [from] Date lower limit, defaults to 30 days before the date used in \&#39;to\&#39;
         * @param {Date} [to] Date upper limit, defaults to now
         * @param {number} [granularityHours] Number of hours to use as the granularity, defaults to 6. The response will contain highest score per interval.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findHeatScores: function (cattleId, from, to, granularityHours, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'cattleId' is not null or undefined
                    (0, common_1.assertParamExists)('findHeatScores', 'cattleId', cattleId);
                    localVarPath = "/cattle-breeding/cows/{cattleId}/heat-scores"
                        .replace("{".concat("cattleId", "}"), encodeURIComponent(String(cattleId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (from !== undefined) {
                        localVarQueryParameter['from'] = (from instanceof Date) ?
                            from.toISOString() :
                            from;
                    }
                    if (to !== undefined) {
                        localVarQueryParameter['to'] = (to instanceof Date) ?
                            to.toISOString() :
                            to;
                    }
                    if (granularityHours !== undefined) {
                        localVarQueryParameter['granularityHours'] = granularityHours;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CowHeatApiAxiosParamCreator = CowHeatApiAxiosParamCreator;
/**
 * CowHeatApi - functional programming interface
 * @export
 */
var CowHeatApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CowHeatApiAxiosParamCreator)(configuration);
    return {
        /**
         * Find heat scores for a cow within an optional time range
         * @param {string} cattleId
         * @param {Date} [from] Date lower limit, defaults to 30 days before the date used in \&#39;to\&#39;
         * @param {Date} [to] Date upper limit, defaults to now
         * @param {number} [granularityHours] Number of hours to use as the granularity, defaults to 6. The response will contain highest score per interval.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findHeatScores: function (cattleId, from, to, granularityHours, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findHeatScores(cattleId, from, to, granularityHours, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CowHeatApiFp = CowHeatApiFp;
/**
 * CowHeatApi - factory interface
 * @export
 */
var CowHeatApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CowHeatApiFp)(configuration);
    return {
        /**
         * Find heat scores for a cow within an optional time range
         * @param {string} cattleId
         * @param {Date} [from] Date lower limit, defaults to 30 days before the date used in \&#39;to\&#39;
         * @param {Date} [to] Date upper limit, defaults to now
         * @param {number} [granularityHours] Number of hours to use as the granularity, defaults to 6. The response will contain highest score per interval.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findHeatScores: function (cattleId, from, to, granularityHours, options) {
            return localVarFp.findHeatScores(cattleId, from, to, granularityHours, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CowHeatApiFactory = CowHeatApiFactory;
/**
 * CowHeatApi - object-oriented interface
 * @export
 * @class CowHeatApi
 * @extends {BaseAPI}
 */
var CowHeatApi = /** @class */ (function (_super) {
    __extends(CowHeatApi, _super);
    function CowHeatApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Find heat scores for a cow within an optional time range
     * @param {string} cattleId
     * @param {Date} [from] Date lower limit, defaults to 30 days before the date used in \&#39;to\&#39;
     * @param {Date} [to] Date upper limit, defaults to now
     * @param {number} [granularityHours] Number of hours to use as the granularity, defaults to 6. The response will contain highest score per interval.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CowHeatApi
     */
    CowHeatApi.prototype.findHeatScores = function (cattleId, from, to, granularityHours, options) {
        var _this = this;
        return (0, exports.CowHeatApiFp)(this.configuration).findHeatScores(cattleId, from, to, granularityHours, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CowHeatApi;
}(base_1.BaseAPI));
exports.CowHeatApi = CowHeatApi;
/**
 * DataApi - axios parameter creator
 * @export
 */
var DataApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Return ICowABEvent
         * @param {Array<string>} cattleIds IDs of cattle to return AB events for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAbEventsForCattle: function (cattleIds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'cattleIds' is not null or undefined
                    (0, common_1.assertParamExists)('findAbEventsForCattle', 'cattleIds', cattleIds);
                    localVarPath = "/cattle-breeding/data/ab-events";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (cattleIds) {
                        localVarQueryParameter['cattleIds'] = cattleIds;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Endpoint used to batch push heat scores, which are used to derive heat events and to serve data for activity graphs
         * @param {Array<ICreateCowHeatScoreEventDTO>} iCreateCowHeatScoreEventDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveHeatScoresBatch: function (iCreateCowHeatScoreEventDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'iCreateCowHeatScoreEventDTO' is not null or undefined
                    (0, common_1.assertParamExists)('saveHeatScoresBatch', 'iCreateCowHeatScoreEventDTO', iCreateCowHeatScoreEventDTO);
                    localVarPath = "/cattle-breeding/data/heat-scores-batch";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateCowHeatScoreEventDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DataApiAxiosParamCreator = DataApiAxiosParamCreator;
/**
 * DataApi - functional programming interface
 * @export
 */
var DataApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DataApiAxiosParamCreator)(configuration);
    return {
        /**
         * Return ICowABEvent
         * @param {Array<string>} cattleIds IDs of cattle to return AB events for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAbEventsForCattle: function (cattleIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findAbEventsForCattle(cattleIds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Endpoint used to batch push heat scores, which are used to derive heat events and to serve data for activity graphs
         * @param {Array<ICreateCowHeatScoreEventDTO>} iCreateCowHeatScoreEventDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveHeatScoresBatch: function (iCreateCowHeatScoreEventDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.saveHeatScoresBatch(iCreateCowHeatScoreEventDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DataApiFp = DataApiFp;
/**
 * DataApi - factory interface
 * @export
 */
var DataApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DataApiFp)(configuration);
    return {
        /**
         * Return ICowABEvent
         * @param {Array<string>} cattleIds IDs of cattle to return AB events for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAbEventsForCattle: function (cattleIds, options) {
            return localVarFp.findAbEventsForCattle(cattleIds, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Endpoint used to batch push heat scores, which are used to derive heat events and to serve data for activity graphs
         * @param {Array<ICreateCowHeatScoreEventDTO>} iCreateCowHeatScoreEventDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveHeatScoresBatch: function (iCreateCowHeatScoreEventDTO, options) {
            return localVarFp.saveHeatScoresBatch(iCreateCowHeatScoreEventDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DataApiFactory = DataApiFactory;
/**
 * DataApi - object-oriented interface
 * @export
 * @class DataApi
 * @extends {BaseAPI}
 */
var DataApi = /** @class */ (function (_super) {
    __extends(DataApi, _super);
    function DataApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Return ICowABEvent
     * @param {Array<string>} cattleIds IDs of cattle to return AB events for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataApi
     */
    DataApi.prototype.findAbEventsForCattle = function (cattleIds, options) {
        var _this = this;
        return (0, exports.DataApiFp)(this.configuration).findAbEventsForCattle(cattleIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Endpoint used to batch push heat scores, which are used to derive heat events and to serve data for activity graphs
     * @param {Array<ICreateCowHeatScoreEventDTO>} iCreateCowHeatScoreEventDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataApi
     */
    DataApi.prototype.saveHeatScoresBatch = function (iCreateCowHeatScoreEventDTO, options) {
        var _this = this;
        return (0, exports.DataApiFp)(this.configuration).saveHeatScoresBatch(iCreateCowHeatScoreEventDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DataApi;
}(base_1.BaseAPI));
exports.DataApi = DataApi;
/**
 * PregnancyApi - axios parameter creator
 * @export
 */
var PregnancyApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * bulk submit pregnancy test results
         * @param {ICreateCowPregnancyTestResultBatchDTO} iCreateCowPregnancyTestResultBatchDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCowPregnancyTestResultBatch: function (iCreateCowPregnancyTestResultBatchDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'iCreateCowPregnancyTestResultBatchDTO' is not null or undefined
                    (0, common_1.assertParamExists)('createCowPregnancyTestResultBatch', 'iCreateCowPregnancyTestResultBatchDTO', iCreateCowPregnancyTestResultBatchDTO);
                    localVarPath = "/cattle-breeding/pregnancy-test";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateCowPregnancyTestResultBatchDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete a pregnancy test
         * @param {string} pregnancyTestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCowPregnancyTest: function (pregnancyTestId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'pregnancyTestId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteCowPregnancyTest', 'pregnancyTestId', pregnancyTestId);
                    localVarPath = "/cattle-breeding/pregnancy-test/{pregnancyTestId}"
                        .replace("{".concat("pregnancyTestId", "}"), encodeURIComponent(String(pregnancyTestId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Fetch pregnancy test results
         * @param {string} [cattleId]
         * @param {Date} [diagnosisDateAfter] diagnosisDate lower limit, defaults to 90 days before the date used in \&#39;to\&#39;
         * @param {Date} [diagnosisDateBefore] diagnosisDate upper limit, defaults to now
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCowPregnancyTestResults: function (cattleId, diagnosisDateAfter, diagnosisDateBefore, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cattle-breeding/pregnancy-test/find";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (cattleId !== undefined) {
                        localVarQueryParameter['cattleId'] = cattleId;
                    }
                    if (diagnosisDateAfter !== undefined) {
                        localVarQueryParameter['diagnosisDateAfter'] = (diagnosisDateAfter instanceof Date) ?
                            diagnosisDateAfter.toISOString() :
                            diagnosisDateAfter;
                    }
                    if (diagnosisDateBefore !== undefined) {
                        localVarQueryParameter['diagnosisDateBefore'] = (diagnosisDateBefore instanceof Date) ?
                            diagnosisDateBefore.toISOString() :
                            diagnosisDateBefore;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Fetches all cows current pregnancy status for the farm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPregnancyStatusesForFarm: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cattle-breeding/pregnancy-status/get-all-for-farm";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.PregnancyApiAxiosParamCreator = PregnancyApiAxiosParamCreator;
/**
 * PregnancyApi - functional programming interface
 * @export
 */
var PregnancyApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PregnancyApiAxiosParamCreator)(configuration);
    return {
        /**
         * bulk submit pregnancy test results
         * @param {ICreateCowPregnancyTestResultBatchDTO} iCreateCowPregnancyTestResultBatchDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCowPregnancyTestResultBatch: function (iCreateCowPregnancyTestResultBatchDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createCowPregnancyTestResultBatch(iCreateCowPregnancyTestResultBatchDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete a pregnancy test
         * @param {string} pregnancyTestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCowPregnancyTest: function (pregnancyTestId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteCowPregnancyTest(pregnancyTestId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Fetch pregnancy test results
         * @param {string} [cattleId]
         * @param {Date} [diagnosisDateAfter] diagnosisDate lower limit, defaults to 90 days before the date used in \&#39;to\&#39;
         * @param {Date} [diagnosisDateBefore] diagnosisDate upper limit, defaults to now
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCowPregnancyTestResults: function (cattleId, diagnosisDateAfter, diagnosisDateBefore, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findCowPregnancyTestResults(cattleId, diagnosisDateAfter, diagnosisDateBefore, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Fetches all cows current pregnancy status for the farm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPregnancyStatusesForFarm: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPregnancyStatusesForFarm(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PregnancyApiFp = PregnancyApiFp;
/**
 * PregnancyApi - factory interface
 * @export
 */
var PregnancyApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PregnancyApiFp)(configuration);
    return {
        /**
         * bulk submit pregnancy test results
         * @param {ICreateCowPregnancyTestResultBatchDTO} iCreateCowPregnancyTestResultBatchDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCowPregnancyTestResultBatch: function (iCreateCowPregnancyTestResultBatchDTO, options) {
            return localVarFp.createCowPregnancyTestResultBatch(iCreateCowPregnancyTestResultBatchDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a pregnancy test
         * @param {string} pregnancyTestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCowPregnancyTest: function (pregnancyTestId, options) {
            return localVarFp.deleteCowPregnancyTest(pregnancyTestId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Fetch pregnancy test results
         * @param {string} [cattleId]
         * @param {Date} [diagnosisDateAfter] diagnosisDate lower limit, defaults to 90 days before the date used in \&#39;to\&#39;
         * @param {Date} [diagnosisDateBefore] diagnosisDate upper limit, defaults to now
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCowPregnancyTestResults: function (cattleId, diagnosisDateAfter, diagnosisDateBefore, options) {
            return localVarFp.findCowPregnancyTestResults(cattleId, diagnosisDateAfter, diagnosisDateBefore, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Fetches all cows current pregnancy status for the farm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPregnancyStatusesForFarm: function (options) {
            return localVarFp.getPregnancyStatusesForFarm(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PregnancyApiFactory = PregnancyApiFactory;
/**
 * PregnancyApi - object-oriented interface
 * @export
 * @class PregnancyApi
 * @extends {BaseAPI}
 */
var PregnancyApi = /** @class */ (function (_super) {
    __extends(PregnancyApi, _super);
    function PregnancyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * bulk submit pregnancy test results
     * @param {ICreateCowPregnancyTestResultBatchDTO} iCreateCowPregnancyTestResultBatchDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PregnancyApi
     */
    PregnancyApi.prototype.createCowPregnancyTestResultBatch = function (iCreateCowPregnancyTestResultBatchDTO, options) {
        var _this = this;
        return (0, exports.PregnancyApiFp)(this.configuration).createCowPregnancyTestResultBatch(iCreateCowPregnancyTestResultBatchDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a pregnancy test
     * @param {string} pregnancyTestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PregnancyApi
     */
    PregnancyApi.prototype.deleteCowPregnancyTest = function (pregnancyTestId, options) {
        var _this = this;
        return (0, exports.PregnancyApiFp)(this.configuration).deleteCowPregnancyTest(pregnancyTestId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Fetch pregnancy test results
     * @param {string} [cattleId]
     * @param {Date} [diagnosisDateAfter] diagnosisDate lower limit, defaults to 90 days before the date used in \&#39;to\&#39;
     * @param {Date} [diagnosisDateBefore] diagnosisDate upper limit, defaults to now
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PregnancyApi
     */
    PregnancyApi.prototype.findCowPregnancyTestResults = function (cattleId, diagnosisDateAfter, diagnosisDateBefore, options) {
        var _this = this;
        return (0, exports.PregnancyApiFp)(this.configuration).findCowPregnancyTestResults(cattleId, diagnosisDateAfter, diagnosisDateBefore, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Fetches all cows current pregnancy status for the farm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PregnancyApi
     */
    PregnancyApi.prototype.getPregnancyStatusesForFarm = function (options) {
        var _this = this;
        return (0, exports.PregnancyApiFp)(this.configuration).getPregnancyStatusesForFarm(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PregnancyApi;
}(base_1.BaseAPI));
exports.PregnancyApi = PregnancyApi;
/**
 * SeasonApi - axios parameter creator
 * @export
 */
var SeasonApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Add a heat event to the ab list
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {string} heatEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addHeatEventToABList: function (seasonId, heatEventId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('addHeatEventToABList', 'seasonId', seasonId);
                    // verify required parameter 'heatEventId' is not null or undefined
                    (0, common_1.assertParamExists)('addHeatEventToABList', 'heatEventId', heatEventId);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/heat-events/{heatEventId}/ab-events"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)))
                        .replace("{".concat("heatEventId", "}"), encodeURIComponent(String(heatEventId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Bulk create heat events and mark them as mated for a list of cattleIds
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {IBulkMarkAsMatedRequestDTO} [iBulkMarkAsMatedRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkMarkAsMated: function (seasonId, iBulkMarkAsMatedRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('bulkMarkAsMated', 'seasonId', seasonId);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/heat-events/bulk-mark-as-mated"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iBulkMarkAsMatedRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Mark all AB events complete for the specified season.
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeABList: function (seasonId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('completeABList', 'seasonId', seasonId);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/heat-events/ab-list/complete"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Bulk create and complete AB events for a list of heat events
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {ICreateAndCompleteAbEventsForHeatEventsRequestDTO} [iCreateAndCompleteAbEventsForHeatEventsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndCompleteAbEventsForHeatEvents: function (seasonId, iCreateAndCompleteAbEventsForHeatEventsRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('createAndCompleteAbEventsForHeatEvents', 'seasonId', seasonId);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/heat-events/ab-events"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateAndCompleteAbEventsForHeatEventsRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Create a calving event
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to add to the current season
         * @param {ICreateCowCalvingEventRequestDTO} iCreateCowCalvingEventRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalvingEvents: function (seasonId, iCreateCowCalvingEventRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('createCalvingEvents', 'seasonId', seasonId);
                    // verify required parameter 'iCreateCowCalvingEventRequestDTO' is not null or undefined
                    (0, common_1.assertParamExists)('createCalvingEvents', 'iCreateCowCalvingEventRequestDTO', iCreateCowCalvingEventRequestDTO);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/calving-events"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateCowCalvingEventRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Create a manual heat event
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {ICreateManualCowHeatEventDTO} iCreateManualCowHeatEventDTO
         * @param {CowHeatEventSourceEnum} [source] Defaults to MANUAL for backwards compatibility
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManualHeatEvent: function (seasonId, iCreateManualCowHeatEventDTO, source, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('createManualHeatEvent', 'seasonId', seasonId);
                    // verify required parameter 'iCreateManualCowHeatEventDTO' is not null or undefined
                    (0, common_1.assertParamExists)('createManualHeatEvent', 'iCreateManualCowHeatEventDTO', iCreateManualCowHeatEventDTO);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/heat-events"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (source !== undefined) {
                        localVarQueryParameter['source'] = source;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateManualCowHeatEventDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Create a new season
         * @param {ICreateSeasonDTO} iCreateSeasonDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSeason: function (iCreateSeasonDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'iCreateSeasonDTO' is not null or undefined
                    (0, common_1.assertParamExists)('createSeason', 'iCreateSeasonDTO', iCreateSeasonDTO);
                    localVarPath = "/cattle-breeding/seasons";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateSeasonDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete an existing AB event
         * @param {string} seasonId
         * @param {string} heatEventId
         * @param {string} abEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteABEvent: function (seasonId, heatEventId, abEventId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteABEvent', 'seasonId', seasonId);
                    // verify required parameter 'heatEventId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteABEvent', 'heatEventId', heatEventId);
                    // verify required parameter 'abEventId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteABEvent', 'abEventId', abEventId);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/heat-events/{heatEventId}/ab-events/{abEventId}"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)))
                        .replace("{".concat("heatEventId", "}"), encodeURIComponent(String(heatEventId)))
                        .replace("{".concat("abEventId", "}"), encodeURIComponent(String(abEventId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete an existing calving event
         * @param {string} seasonId
         * @param {string} calvingEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalvingEvent: function (seasonId, calvingEventId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteCalvingEvent', 'seasonId', seasonId);
                    // verify required parameter 'calvingEventId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteCalvingEvent', 'calvingEventId', calvingEventId);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/calving-events/{calvingEventId}"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)))
                        .replace("{".concat("calvingEventId", "}"), encodeURIComponent(String(calvingEventId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete an existing heat event
         * @param {string} seasonId
         * @param {string} heatEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHeatEvent: function (seasonId, heatEventId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteHeatEvent', 'seasonId', seasonId);
                    // verify required parameter 'heatEventId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteHeatEvent', 'heatEventId', heatEventId);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/heat-events/{heatEventId}"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)))
                        .replace("{".concat("heatEventId", "}"), encodeURIComponent(String(heatEventId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete an existing season
         * @param {string} seasonId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSeason: function (seasonId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteSeason', 'seasonId', seasonId);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Find the active mating kpi warning based on the user\'s current datetime, relative to PSM and their current season metrics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findActiveMatingKPIWarning: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cattle-breeding/seasons/metrics/active-mating-kpi-warning";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Find all seasons for a farm id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllSeasons: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cattle-breeding/seasons/find-all";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Find cattle calving events
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find within the current season
         * @param {string} [cattleId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCalvingEvents: function (seasonId, cattleId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('findCalvingEvents', 'seasonId', seasonId);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/calving-events"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (cattleId !== undefined) {
                        localVarQueryParameter['cattleId'] = cattleId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Find mating length for a season
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findFarmSeasonMatingLength: function (seasonId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('findFarmSeasonMatingLength', 'seasonId', seasonId);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/mating-length"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Find farm season metrics by metric type and seasonId
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {SeasonMetricTypeEnum} metricType Which metric to find values for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findFarmSeasonMetrics: function (seasonId, metricType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('findFarmSeasonMetrics', 'seasonId', seasonId);
                    // verify required parameter 'metricType' is not null or undefined
                    (0, common_1.assertParamExists)('findFarmSeasonMetrics', 'metricType', metricType);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/farm-season-metrics"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (metricType !== undefined) {
                        localVarQueryParameter['metricType'] = metricType;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Find metrics for forecasted in-calf rate for a season
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findForecastedInCalfRateMetricData: function (seasonId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('findForecastedInCalfRateMetricData', 'seasonId', seasonId);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/metric-data/forecasted-in-calf-rate"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Find metric graph for forecasted in-calf rate from the current date
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {Date} startDate The start date to display forecasted in-calf
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findForecastedInCalfRateMetricGraph: function (seasonId, startDate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('findForecastedInCalfRateMetricGraph', 'seasonId', seasonId);
                    // verify required parameter 'startDate' is not null or undefined
                    (0, common_1.assertParamExists)('findForecastedInCalfRateMetricGraph', 'startDate', startDate);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/metric-data/forecasted-in-calf-rate/graph"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (startDate !== undefined) {
                        localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                            startDate.toISOString() :
                            startDate;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Find cattle heat events
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {number} limit The maximum number of items to be returned
         * @param {string} [cattleId]
         * @param {Date} [firstDetectedAtBefore] If present, the results will be heat events with a firstDetectedAt earlier than this datetime
         * @param {Date} [firstDetectedAtAfter] If present, the results will be heat events with a firstDetectedAt later than this datetime
         * @param {Date} [overlappingDate] If present, just the cow heat events that have a firstDetectedAt within the \&#39;active\&#39; range of this value will be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findHeatEvents: function (seasonId, limit, cattleId, firstDetectedAtBefore, firstDetectedAtAfter, overlappingDate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('findHeatEvents', 'seasonId', seasonId);
                    // verify required parameter 'limit' is not null or undefined
                    (0, common_1.assertParamExists)('findHeatEvents', 'limit', limit);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/heat-events"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (cattleId !== undefined) {
                        localVarQueryParameter['cattleId'] = cattleId;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (firstDetectedAtBefore !== undefined) {
                        localVarQueryParameter['firstDetectedAtBefore'] = (firstDetectedAtBefore instanceof Date) ?
                            firstDetectedAtBefore.toISOString() :
                            firstDetectedAtBefore;
                    }
                    if (firstDetectedAtAfter !== undefined) {
                        localVarQueryParameter['firstDetectedAtAfter'] = (firstDetectedAtAfter instanceof Date) ?
                            firstDetectedAtAfter.toISOString() :
                            firstDetectedAtAfter;
                    }
                    if (overlappingDate !== undefined) {
                        localVarQueryParameter['overlappingDate'] = (overlappingDate instanceof Date) ?
                            overlappingDate.toISOString() :
                            overlappingDate;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Find metrics for in calf for a season
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findInCalfMetricData: function (seasonId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('findInCalfMetricData', 'seasonId', seasonId);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/metric-data/in-calf"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Find metric graph, in-calf from PSM
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {Date} startDate The start date to display in-calf
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findInCalfMetricGraph: function (seasonId, startDate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('findInCalfMetricGraph', 'seasonId', seasonId);
                    // verify required parameter 'startDate' is not null or undefined
                    (0, common_1.assertParamExists)('findInCalfMetricGraph', 'startDate', startDate);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/metric-data/in-calf/graph"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (startDate !== undefined) {
                        localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                            startDate.toISOString() :
                            startDate;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Find metric data for a season
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {number} [daysSinceLastHeat] Defaults to 26, used to find cycling and non-cycling cows
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMetricData: function (seasonId, daysSinceLastHeat, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('findMetricData', 'seasonId', seasonId);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/metric-data"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (daysSinceLastHeat !== undefined) {
                        localVarQueryParameter['daysSinceLastHeat'] = daysSinceLastHeat;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Find metric graph, cycling
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {Date} startDate The start date to display percent cycling
         * @param {Date} endDate The end date to display percent cycling
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMetricGraphCycling: function (seasonId, startDate, endDate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('findMetricGraphCycling', 'seasonId', seasonId);
                    // verify required parameter 'startDate' is not null or undefined
                    (0, common_1.assertParamExists)('findMetricGraphCycling', 'startDate', startDate);
                    // verify required parameter 'endDate' is not null or undefined
                    (0, common_1.assertParamExists)('findMetricGraphCycling', 'endDate', endDate);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/metric-data/cycling"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (startDate !== undefined) {
                        localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                            startDate.toISOString() :
                            startDate;
                    }
                    if (endDate !== undefined) {
                        localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                            endDate.toISOString() :
                            endDate;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Find metric graph, day to first heat
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMetricGraphDaysToFirstHeat: function (seasonId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('findMetricGraphDaysToFirstHeat', 'seasonId', seasonId);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/metric-data/days-to-first-heat"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Find metric graph, non-return
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {Date} startDate The start date to display non-return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMetricGraphNonReturn: function (seasonId, startDate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('findMetricGraphNonReturn', 'seasonId', seasonId);
                    // verify required parameter 'startDate' is not null or undefined
                    (0, common_1.assertParamExists)('findMetricGraphNonReturn', 'startDate', startDate);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/metric-data/non-return/graph"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (startDate !== undefined) {
                        localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                            startDate.toISOString() :
                            startDate;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Find metric graph, on heat
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {Date} startDate The start date to display cow on heat
         * @param {Date} endDate The end date to display cow on heat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMetricGraphOnHeat: function (seasonId, startDate, endDate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('findMetricGraphOnHeat', 'seasonId', seasonId);
                    // verify required parameter 'startDate' is not null or undefined
                    (0, common_1.assertParamExists)('findMetricGraphOnHeat', 'startDate', startDate);
                    // verify required parameter 'endDate' is not null or undefined
                    (0, common_1.assertParamExists)('findMetricGraphOnHeat', 'endDate', endDate);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/metric-data/on-heat"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (startDate !== undefined) {
                        localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                            startDate.toISOString() :
                            startDate;
                    }
                    if (endDate !== undefined) {
                        localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                            endDate.toISOString() :
                            endDate;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Find metric graph, submission
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {Date} [endDate] The end date to display submitted percent, default of PSM + 12 weeks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMetricGraphSubmission: function (seasonId, endDate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('findMetricGraphSubmission', 'seasonId', seasonId);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/metric-data/submission"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (endDate !== undefined) {
                        localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                            endDate.toISOString() :
                            endDate;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Find the previous equivalent season relative to the given season
         * @param {string} seasonId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPreviousEquivalentSeason: function (seasonId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('findPreviousEquivalentSeason', 'seasonId', seasonId);
                    localVarPath = "/cattle-breeding/seasons/find-previous-equivalent/{seasonId}"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Find a season by id
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSeason: function (seasonId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('findSeason', 'seasonId', seasonId);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {number} [radiusInKm] The radius around the given farm to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSeasonMetricsBenchmarks: function (seasonId, radiusInKm, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('findSeasonMetricsBenchmarks', 'seasonId', seasonId);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/metric-data/benchmarks"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (radiusInKm !== undefined) {
                        localVarQueryParameter['radiusInKm'] = radiusInKm;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Find cattle for respective season metric
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {SeasonMetricsGroupEnum} seasonMetricGroup Returns cattle for the metric grouping
         * @param {number} limit the maximum number of items to be returned in this call
         * @param {number} offset paginate
         * @param {ISeasonMetricsRequestDTO} [iSeasonMetricsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSeasonMetricsCattle: function (seasonId, seasonMetricGroup, limit, offset, iSeasonMetricsRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('findSeasonMetricsCattle', 'seasonId', seasonId);
                    // verify required parameter 'seasonMetricGroup' is not null or undefined
                    (0, common_1.assertParamExists)('findSeasonMetricsCattle', 'seasonMetricGroup', seasonMetricGroup);
                    // verify required parameter 'limit' is not null or undefined
                    (0, common_1.assertParamExists)('findSeasonMetricsCattle', 'limit', limit);
                    // verify required parameter 'offset' is not null or undefined
                    (0, common_1.assertParamExists)('findSeasonMetricsCattle', 'offset', offset);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/metrics/cattle/search"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (seasonMetricGroup !== undefined) {
                        localVarQueryParameter['seasonMetricGroup'] = seasonMetricGroup;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iSeasonMetricsRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Find metric summary for a season
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {ISeasonMetricsRequestDTO} [iSeasonMetricsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSeasonMetricsSummary: function (seasonId, iSeasonMetricsRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('findSeasonMetricsSummary', 'seasonId', seasonId);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/metrics/summary/search"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iSeasonMetricsRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Retrieve AB list for specified season
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getABList: function (seasonId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('getABList', 'seasonId', seasonId);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/heat-events/ab-list"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Breeding information for season for the passed cow
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {string} cattleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCowForSeason: function (seasonId, cattleId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('getCowForSeason', 'seasonId', seasonId);
                    // verify required parameter 'cattleId' is not null or undefined
                    (0, common_1.assertParamExists)('getCowForSeason', 'cattleId', cattleId);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/cows/{cattleId}"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)))
                        .replace("{".concat("cattleId", "}"), encodeURIComponent(String(cattleId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get reproduction event summaries per cow for the whole farm
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {boolean} [getExcludedInSeason] Defaults to false if undefined, if true we return summaries for excluded cows
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCowReproductionSummaries: function (seasonId, getExcludedInSeason, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('getCowReproductionSummaries', 'seasonId', seasonId);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/reproduction/cow-summaries"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (getExcludedInSeason !== undefined) {
                        localVarQueryParameter['getExcludedInSeason'] = getExcludedInSeason;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Cow seasons for cattle in a farm.
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCowsForSeason: function (seasonId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('getCowsForSeason', 'seasonId', seasonId);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/cows"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Internal cron call to mark all old heat events with AB events \"in calf\".
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveInseminationResultStatus: function (seasonId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('resolveInseminationResultStatus', 'seasonId', seasonId);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/heat-events/resolve-insemination-result-status"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update an existing calving event
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to update events in the current season
         * @param {string} calvingEventId
         * @param {IUpdateCowCalvingEventDTO} iUpdateCowCalvingEventDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalvingEvent: function (seasonId, calvingEventId, iUpdateCowCalvingEventDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('updateCalvingEvent', 'seasonId', seasonId);
                    // verify required parameter 'calvingEventId' is not null or undefined
                    (0, common_1.assertParamExists)('updateCalvingEvent', 'calvingEventId', calvingEventId);
                    // verify required parameter 'iUpdateCowCalvingEventDTO' is not null or undefined
                    (0, common_1.assertParamExists)('updateCalvingEvent', 'iUpdateCowCalvingEventDTO', iUpdateCowCalvingEventDTO);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/calving-events/{calvingEventId}"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)))
                        .replace("{".concat("calvingEventId", "}"), encodeURIComponent(String(calvingEventId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateCowCalvingEventDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update if cattleIds are included or excluded in the season
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {IUpdateCowsIncludedInSeasonDTO} iUpdateCowsIncludedInSeasonDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCowSeason: function (seasonId, iUpdateCowsIncludedInSeasonDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('updateCowSeason', 'seasonId', seasonId);
                    // verify required parameter 'iUpdateCowsIncludedInSeasonDTO' is not null or undefined
                    (0, common_1.assertParamExists)('updateCowSeason', 'iUpdateCowsIncludedInSeasonDTO', iUpdateCowsIncludedInSeasonDTO);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/cows"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateCowsIncludedInSeasonDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update an existing heat event
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {string} heatEventId
         * @param {IUpdateCowHeatEventDTO} iUpdateCowHeatEventDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHeatEvent: function (seasonId, heatEventId, iUpdateCowHeatEventDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('updateHeatEvent', 'seasonId', seasonId);
                    // verify required parameter 'heatEventId' is not null or undefined
                    (0, common_1.assertParamExists)('updateHeatEvent', 'heatEventId', heatEventId);
                    // verify required parameter 'iUpdateCowHeatEventDTO' is not null or undefined
                    (0, common_1.assertParamExists)('updateHeatEvent', 'iUpdateCowHeatEventDTO', iUpdateCowHeatEventDTO);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}/heat-events/{heatEventId}"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)))
                        .replace("{".concat("heatEventId", "}"), encodeURIComponent(String(heatEventId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateCowHeatEventDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update an existing season
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to update the current season
         * @param {IUpdateSeasonDTO} iUpdateSeasonDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeason: function (seasonId, iUpdateSeasonDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'seasonId' is not null or undefined
                    (0, common_1.assertParamExists)('updateSeason', 'seasonId', seasonId);
                    // verify required parameter 'iUpdateSeasonDTO' is not null or undefined
                    (0, common_1.assertParamExists)('updateSeason', 'iUpdateSeasonDTO', iUpdateSeasonDTO);
                    localVarPath = "/cattle-breeding/seasons/{seasonId}"
                        .replace("{".concat("seasonId", "}"), encodeURIComponent(String(seasonId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateSeasonDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.SeasonApiAxiosParamCreator = SeasonApiAxiosParamCreator;
/**
 * SeasonApi - functional programming interface
 * @export
 */
var SeasonApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SeasonApiAxiosParamCreator)(configuration);
    return {
        /**
         * Add a heat event to the ab list
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {string} heatEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addHeatEventToABList: function (seasonId, heatEventId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addHeatEventToABList(seasonId, heatEventId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Bulk create heat events and mark them as mated for a list of cattleIds
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {IBulkMarkAsMatedRequestDTO} [iBulkMarkAsMatedRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkMarkAsMated: function (seasonId, iBulkMarkAsMatedRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.bulkMarkAsMated(seasonId, iBulkMarkAsMatedRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Mark all AB events complete for the specified season.
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeABList: function (seasonId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.completeABList(seasonId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Bulk create and complete AB events for a list of heat events
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {ICreateAndCompleteAbEventsForHeatEventsRequestDTO} [iCreateAndCompleteAbEventsForHeatEventsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndCompleteAbEventsForHeatEvents: function (seasonId, iCreateAndCompleteAbEventsForHeatEventsRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createAndCompleteAbEventsForHeatEvents(seasonId, iCreateAndCompleteAbEventsForHeatEventsRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create a calving event
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to add to the current season
         * @param {ICreateCowCalvingEventRequestDTO} iCreateCowCalvingEventRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalvingEvents: function (seasonId, iCreateCowCalvingEventRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createCalvingEvents(seasonId, iCreateCowCalvingEventRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create a manual heat event
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {ICreateManualCowHeatEventDTO} iCreateManualCowHeatEventDTO
         * @param {CowHeatEventSourceEnum} [source] Defaults to MANUAL for backwards compatibility
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManualHeatEvent: function (seasonId, iCreateManualCowHeatEventDTO, source, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createManualHeatEvent(seasonId, iCreateManualCowHeatEventDTO, source, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create a new season
         * @param {ICreateSeasonDTO} iCreateSeasonDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSeason: function (iCreateSeasonDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSeason(iCreateSeasonDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete an existing AB event
         * @param {string} seasonId
         * @param {string} heatEventId
         * @param {string} abEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteABEvent: function (seasonId, heatEventId, abEventId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteABEvent(seasonId, heatEventId, abEventId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete an existing calving event
         * @param {string} seasonId
         * @param {string} calvingEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalvingEvent: function (seasonId, calvingEventId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteCalvingEvent(seasonId, calvingEventId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete an existing heat event
         * @param {string} seasonId
         * @param {string} heatEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHeatEvent: function (seasonId, heatEventId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteHeatEvent(seasonId, heatEventId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete an existing season
         * @param {string} seasonId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSeason: function (seasonId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteSeason(seasonId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Find the active mating kpi warning based on the user\'s current datetime, relative to PSM and their current season metrics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findActiveMatingKPIWarning: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findActiveMatingKPIWarning(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Find all seasons for a farm id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllSeasons: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findAllSeasons(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Find cattle calving events
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find within the current season
         * @param {string} [cattleId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCalvingEvents: function (seasonId, cattleId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findCalvingEvents(seasonId, cattleId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Find mating length for a season
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findFarmSeasonMatingLength: function (seasonId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findFarmSeasonMatingLength(seasonId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Find farm season metrics by metric type and seasonId
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {SeasonMetricTypeEnum} metricType Which metric to find values for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findFarmSeasonMetrics: function (seasonId, metricType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findFarmSeasonMetrics(seasonId, metricType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Find metrics for forecasted in-calf rate for a season
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findForecastedInCalfRateMetricData: function (seasonId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findForecastedInCalfRateMetricData(seasonId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Find metric graph for forecasted in-calf rate from the current date
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {Date} startDate The start date to display forecasted in-calf
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findForecastedInCalfRateMetricGraph: function (seasonId, startDate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findForecastedInCalfRateMetricGraph(seasonId, startDate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Find cattle heat events
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {number} limit The maximum number of items to be returned
         * @param {string} [cattleId]
         * @param {Date} [firstDetectedAtBefore] If present, the results will be heat events with a firstDetectedAt earlier than this datetime
         * @param {Date} [firstDetectedAtAfter] If present, the results will be heat events with a firstDetectedAt later than this datetime
         * @param {Date} [overlappingDate] If present, just the cow heat events that have a firstDetectedAt within the \&#39;active\&#39; range of this value will be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findHeatEvents: function (seasonId, limit, cattleId, firstDetectedAtBefore, firstDetectedAtAfter, overlappingDate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findHeatEvents(seasonId, limit, cattleId, firstDetectedAtBefore, firstDetectedAtAfter, overlappingDate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Find metrics for in calf for a season
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findInCalfMetricData: function (seasonId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findInCalfMetricData(seasonId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Find metric graph, in-calf from PSM
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {Date} startDate The start date to display in-calf
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findInCalfMetricGraph: function (seasonId, startDate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findInCalfMetricGraph(seasonId, startDate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Find metric data for a season
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {number} [daysSinceLastHeat] Defaults to 26, used to find cycling and non-cycling cows
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMetricData: function (seasonId, daysSinceLastHeat, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findMetricData(seasonId, daysSinceLastHeat, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Find metric graph, cycling
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {Date} startDate The start date to display percent cycling
         * @param {Date} endDate The end date to display percent cycling
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMetricGraphCycling: function (seasonId, startDate, endDate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findMetricGraphCycling(seasonId, startDate, endDate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Find metric graph, day to first heat
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMetricGraphDaysToFirstHeat: function (seasonId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findMetricGraphDaysToFirstHeat(seasonId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Find metric graph, non-return
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {Date} startDate The start date to display non-return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMetricGraphNonReturn: function (seasonId, startDate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findMetricGraphNonReturn(seasonId, startDate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Find metric graph, on heat
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {Date} startDate The start date to display cow on heat
         * @param {Date} endDate The end date to display cow on heat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMetricGraphOnHeat: function (seasonId, startDate, endDate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findMetricGraphOnHeat(seasonId, startDate, endDate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Find metric graph, submission
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {Date} [endDate] The end date to display submitted percent, default of PSM + 12 weeks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMetricGraphSubmission: function (seasonId, endDate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findMetricGraphSubmission(seasonId, endDate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Find the previous equivalent season relative to the given season
         * @param {string} seasonId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPreviousEquivalentSeason: function (seasonId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findPreviousEquivalentSeason(seasonId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Find a season by id
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSeason: function (seasonId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findSeason(seasonId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {number} [radiusInKm] The radius around the given farm to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSeasonMetricsBenchmarks: function (seasonId, radiusInKm, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findSeasonMetricsBenchmarks(seasonId, radiusInKm, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Find cattle for respective season metric
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {SeasonMetricsGroupEnum} seasonMetricGroup Returns cattle for the metric grouping
         * @param {number} limit the maximum number of items to be returned in this call
         * @param {number} offset paginate
         * @param {ISeasonMetricsRequestDTO} [iSeasonMetricsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSeasonMetricsCattle: function (seasonId, seasonMetricGroup, limit, offset, iSeasonMetricsRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findSeasonMetricsCattle(seasonId, seasonMetricGroup, limit, offset, iSeasonMetricsRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Find metric summary for a season
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {ISeasonMetricsRequestDTO} [iSeasonMetricsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSeasonMetricsSummary: function (seasonId, iSeasonMetricsRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findSeasonMetricsSummary(seasonId, iSeasonMetricsRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieve AB list for specified season
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getABList: function (seasonId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getABList(seasonId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Breeding information for season for the passed cow
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {string} cattleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCowForSeason: function (seasonId, cattleId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCowForSeason(seasonId, cattleId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get reproduction event summaries per cow for the whole farm
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {boolean} [getExcludedInSeason] Defaults to false if undefined, if true we return summaries for excluded cows
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCowReproductionSummaries: function (seasonId, getExcludedInSeason, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCowReproductionSummaries(seasonId, getExcludedInSeason, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Cow seasons for cattle in a farm.
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCowsForSeason: function (seasonId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCowsForSeason(seasonId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Internal cron call to mark all old heat events with AB events \"in calf\".
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveInseminationResultStatus: function (seasonId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.resolveInseminationResultStatus(seasonId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update an existing calving event
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to update events in the current season
         * @param {string} calvingEventId
         * @param {IUpdateCowCalvingEventDTO} iUpdateCowCalvingEventDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalvingEvent: function (seasonId, calvingEventId, iUpdateCowCalvingEventDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCalvingEvent(seasonId, calvingEventId, iUpdateCowCalvingEventDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update if cattleIds are included or excluded in the season
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {IUpdateCowsIncludedInSeasonDTO} iUpdateCowsIncludedInSeasonDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCowSeason: function (seasonId, iUpdateCowsIncludedInSeasonDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCowSeason(seasonId, iUpdateCowsIncludedInSeasonDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update an existing heat event
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {string} heatEventId
         * @param {IUpdateCowHeatEventDTO} iUpdateCowHeatEventDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHeatEvent: function (seasonId, heatEventId, iUpdateCowHeatEventDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateHeatEvent(seasonId, heatEventId, iUpdateCowHeatEventDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update an existing season
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to update the current season
         * @param {IUpdateSeasonDTO} iUpdateSeasonDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeason: function (seasonId, iUpdateSeasonDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSeason(seasonId, iUpdateSeasonDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SeasonApiFp = SeasonApiFp;
/**
 * SeasonApi - factory interface
 * @export
 */
var SeasonApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SeasonApiFp)(configuration);
    return {
        /**
         * Add a heat event to the ab list
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {string} heatEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addHeatEventToABList: function (seasonId, heatEventId, options) {
            return localVarFp.addHeatEventToABList(seasonId, heatEventId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Bulk create heat events and mark them as mated for a list of cattleIds
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {IBulkMarkAsMatedRequestDTO} [iBulkMarkAsMatedRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkMarkAsMated: function (seasonId, iBulkMarkAsMatedRequestDTO, options) {
            return localVarFp.bulkMarkAsMated(seasonId, iBulkMarkAsMatedRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Mark all AB events complete for the specified season.
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeABList: function (seasonId, options) {
            return localVarFp.completeABList(seasonId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Bulk create and complete AB events for a list of heat events
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {ICreateAndCompleteAbEventsForHeatEventsRequestDTO} [iCreateAndCompleteAbEventsForHeatEventsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndCompleteAbEventsForHeatEvents: function (seasonId, iCreateAndCompleteAbEventsForHeatEventsRequestDTO, options) {
            return localVarFp.createAndCompleteAbEventsForHeatEvents(seasonId, iCreateAndCompleteAbEventsForHeatEventsRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a calving event
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to add to the current season
         * @param {ICreateCowCalvingEventRequestDTO} iCreateCowCalvingEventRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalvingEvents: function (seasonId, iCreateCowCalvingEventRequestDTO, options) {
            return localVarFp.createCalvingEvents(seasonId, iCreateCowCalvingEventRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a manual heat event
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {ICreateManualCowHeatEventDTO} iCreateManualCowHeatEventDTO
         * @param {CowHeatEventSourceEnum} [source] Defaults to MANUAL for backwards compatibility
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManualHeatEvent: function (seasonId, iCreateManualCowHeatEventDTO, source, options) {
            return localVarFp.createManualHeatEvent(seasonId, iCreateManualCowHeatEventDTO, source, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a new season
         * @param {ICreateSeasonDTO} iCreateSeasonDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSeason: function (iCreateSeasonDTO, options) {
            return localVarFp.createSeason(iCreateSeasonDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete an existing AB event
         * @param {string} seasonId
         * @param {string} heatEventId
         * @param {string} abEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteABEvent: function (seasonId, heatEventId, abEventId, options) {
            return localVarFp.deleteABEvent(seasonId, heatEventId, abEventId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete an existing calving event
         * @param {string} seasonId
         * @param {string} calvingEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalvingEvent: function (seasonId, calvingEventId, options) {
            return localVarFp.deleteCalvingEvent(seasonId, calvingEventId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete an existing heat event
         * @param {string} seasonId
         * @param {string} heatEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHeatEvent: function (seasonId, heatEventId, options) {
            return localVarFp.deleteHeatEvent(seasonId, heatEventId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete an existing season
         * @param {string} seasonId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSeason: function (seasonId, options) {
            return localVarFp.deleteSeason(seasonId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Find the active mating kpi warning based on the user\'s current datetime, relative to PSM and their current season metrics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findActiveMatingKPIWarning: function (options) {
            return localVarFp.findActiveMatingKPIWarning(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Find all seasons for a farm id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllSeasons: function (options) {
            return localVarFp.findAllSeasons(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Find cattle calving events
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find within the current season
         * @param {string} [cattleId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCalvingEvents: function (seasonId, cattleId, options) {
            return localVarFp.findCalvingEvents(seasonId, cattleId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Find mating length for a season
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findFarmSeasonMatingLength: function (seasonId, options) {
            return localVarFp.findFarmSeasonMatingLength(seasonId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Find farm season metrics by metric type and seasonId
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {SeasonMetricTypeEnum} metricType Which metric to find values for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findFarmSeasonMetrics: function (seasonId, metricType, options) {
            return localVarFp.findFarmSeasonMetrics(seasonId, metricType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Find metrics for forecasted in-calf rate for a season
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findForecastedInCalfRateMetricData: function (seasonId, options) {
            return localVarFp.findForecastedInCalfRateMetricData(seasonId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Find metric graph for forecasted in-calf rate from the current date
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {Date} startDate The start date to display forecasted in-calf
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findForecastedInCalfRateMetricGraph: function (seasonId, startDate, options) {
            return localVarFp.findForecastedInCalfRateMetricGraph(seasonId, startDate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Find cattle heat events
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {number} limit The maximum number of items to be returned
         * @param {string} [cattleId]
         * @param {Date} [firstDetectedAtBefore] If present, the results will be heat events with a firstDetectedAt earlier than this datetime
         * @param {Date} [firstDetectedAtAfter] If present, the results will be heat events with a firstDetectedAt later than this datetime
         * @param {Date} [overlappingDate] If present, just the cow heat events that have a firstDetectedAt within the \&#39;active\&#39; range of this value will be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findHeatEvents: function (seasonId, limit, cattleId, firstDetectedAtBefore, firstDetectedAtAfter, overlappingDate, options) {
            return localVarFp.findHeatEvents(seasonId, limit, cattleId, firstDetectedAtBefore, firstDetectedAtAfter, overlappingDate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Find metrics for in calf for a season
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findInCalfMetricData: function (seasonId, options) {
            return localVarFp.findInCalfMetricData(seasonId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Find metric graph, in-calf from PSM
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {Date} startDate The start date to display in-calf
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findInCalfMetricGraph: function (seasonId, startDate, options) {
            return localVarFp.findInCalfMetricGraph(seasonId, startDate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Find metric data for a season
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {number} [daysSinceLastHeat] Defaults to 26, used to find cycling and non-cycling cows
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMetricData: function (seasonId, daysSinceLastHeat, options) {
            return localVarFp.findMetricData(seasonId, daysSinceLastHeat, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Find metric graph, cycling
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {Date} startDate The start date to display percent cycling
         * @param {Date} endDate The end date to display percent cycling
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMetricGraphCycling: function (seasonId, startDate, endDate, options) {
            return localVarFp.findMetricGraphCycling(seasonId, startDate, endDate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Find metric graph, day to first heat
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMetricGraphDaysToFirstHeat: function (seasonId, options) {
            return localVarFp.findMetricGraphDaysToFirstHeat(seasonId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Find metric graph, non-return
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {Date} startDate The start date to display non-return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMetricGraphNonReturn: function (seasonId, startDate, options) {
            return localVarFp.findMetricGraphNonReturn(seasonId, startDate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Find metric graph, on heat
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {Date} startDate The start date to display cow on heat
         * @param {Date} endDate The end date to display cow on heat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMetricGraphOnHeat: function (seasonId, startDate, endDate, options) {
            return localVarFp.findMetricGraphOnHeat(seasonId, startDate, endDate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Find metric graph, submission
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {Date} [endDate] The end date to display submitted percent, default of PSM + 12 weeks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMetricGraphSubmission: function (seasonId, endDate, options) {
            return localVarFp.findMetricGraphSubmission(seasonId, endDate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Find the previous equivalent season relative to the given season
         * @param {string} seasonId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPreviousEquivalentSeason: function (seasonId, options) {
            return localVarFp.findPreviousEquivalentSeason(seasonId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Find a season by id
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSeason: function (seasonId, options) {
            return localVarFp.findSeason(seasonId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {number} [radiusInKm] The radius around the given farm to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSeasonMetricsBenchmarks: function (seasonId, radiusInKm, options) {
            return localVarFp.findSeasonMetricsBenchmarks(seasonId, radiusInKm, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Find cattle for respective season metric
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {SeasonMetricsGroupEnum} seasonMetricGroup Returns cattle for the metric grouping
         * @param {number} limit the maximum number of items to be returned in this call
         * @param {number} offset paginate
         * @param {ISeasonMetricsRequestDTO} [iSeasonMetricsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSeasonMetricsCattle: function (seasonId, seasonMetricGroup, limit, offset, iSeasonMetricsRequestDTO, options) {
            return localVarFp.findSeasonMetricsCattle(seasonId, seasonMetricGroup, limit, offset, iSeasonMetricsRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Find metric summary for a season
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {ISeasonMetricsRequestDTO} [iSeasonMetricsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSeasonMetricsSummary: function (seasonId, iSeasonMetricsRequestDTO, options) {
            return localVarFp.findSeasonMetricsSummary(seasonId, iSeasonMetricsRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieve AB list for specified season
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getABList: function (seasonId, options) {
            return localVarFp.getABList(seasonId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Breeding information for season for the passed cow
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {string} cattleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCowForSeason: function (seasonId, cattleId, options) {
            return localVarFp.getCowForSeason(seasonId, cattleId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get reproduction event summaries per cow for the whole farm
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {boolean} [getExcludedInSeason] Defaults to false if undefined, if true we return summaries for excluded cows
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCowReproductionSummaries: function (seasonId, getExcludedInSeason, options) {
            return localVarFp.getCowReproductionSummaries(seasonId, getExcludedInSeason, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Cow seasons for cattle in a farm.
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCowsForSeason: function (seasonId, options) {
            return localVarFp.getCowsForSeason(seasonId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Internal cron call to mark all old heat events with AB events \"in calf\".
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveInseminationResultStatus: function (seasonId, options) {
            return localVarFp.resolveInseminationResultStatus(seasonId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update an existing calving event
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to update events in the current season
         * @param {string} calvingEventId
         * @param {IUpdateCowCalvingEventDTO} iUpdateCowCalvingEventDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalvingEvent: function (seasonId, calvingEventId, iUpdateCowCalvingEventDTO, options) {
            return localVarFp.updateCalvingEvent(seasonId, calvingEventId, iUpdateCowCalvingEventDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update if cattleIds are included or excluded in the season
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {IUpdateCowsIncludedInSeasonDTO} iUpdateCowsIncludedInSeasonDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCowSeason: function (seasonId, iUpdateCowsIncludedInSeasonDTO, options) {
            return localVarFp.updateCowSeason(seasonId, iUpdateCowsIncludedInSeasonDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update an existing heat event
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
         * @param {string} heatEventId
         * @param {IUpdateCowHeatEventDTO} iUpdateCowHeatEventDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHeatEvent: function (seasonId, heatEventId, iUpdateCowHeatEventDTO, options) {
            return localVarFp.updateHeatEvent(seasonId, heatEventId, iUpdateCowHeatEventDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update an existing season
         * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to update the current season
         * @param {IUpdateSeasonDTO} iUpdateSeasonDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeason: function (seasonId, iUpdateSeasonDTO, options) {
            return localVarFp.updateSeason(seasonId, iUpdateSeasonDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SeasonApiFactory = SeasonApiFactory;
/**
 * SeasonApi - object-oriented interface
 * @export
 * @class SeasonApi
 * @extends {BaseAPI}
 */
var SeasonApi = /** @class */ (function (_super) {
    __extends(SeasonApi, _super);
    function SeasonApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Add a heat event to the ab list
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {string} heatEventId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.addHeatEventToABList = function (seasonId, heatEventId, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).addHeatEventToABList(seasonId, heatEventId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Bulk create heat events and mark them as mated for a list of cattleIds
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {IBulkMarkAsMatedRequestDTO} [iBulkMarkAsMatedRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.bulkMarkAsMated = function (seasonId, iBulkMarkAsMatedRequestDTO, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).bulkMarkAsMated(seasonId, iBulkMarkAsMatedRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Mark all AB events complete for the specified season.
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.completeABList = function (seasonId, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).completeABList(seasonId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Bulk create and complete AB events for a list of heat events
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {ICreateAndCompleteAbEventsForHeatEventsRequestDTO} [iCreateAndCompleteAbEventsForHeatEventsRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.createAndCompleteAbEventsForHeatEvents = function (seasonId, iCreateAndCompleteAbEventsForHeatEventsRequestDTO, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).createAndCompleteAbEventsForHeatEvents(seasonId, iCreateAndCompleteAbEventsForHeatEventsRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a calving event
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to add to the current season
     * @param {ICreateCowCalvingEventRequestDTO} iCreateCowCalvingEventRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.createCalvingEvents = function (seasonId, iCreateCowCalvingEventRequestDTO, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).createCalvingEvents(seasonId, iCreateCowCalvingEventRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a manual heat event
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {ICreateManualCowHeatEventDTO} iCreateManualCowHeatEventDTO
     * @param {CowHeatEventSourceEnum} [source] Defaults to MANUAL for backwards compatibility
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.createManualHeatEvent = function (seasonId, iCreateManualCowHeatEventDTO, source, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).createManualHeatEvent(seasonId, iCreateManualCowHeatEventDTO, source, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a new season
     * @param {ICreateSeasonDTO} iCreateSeasonDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.createSeason = function (iCreateSeasonDTO, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).createSeason(iCreateSeasonDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete an existing AB event
     * @param {string} seasonId
     * @param {string} heatEventId
     * @param {string} abEventId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.deleteABEvent = function (seasonId, heatEventId, abEventId, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).deleteABEvent(seasonId, heatEventId, abEventId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete an existing calving event
     * @param {string} seasonId
     * @param {string} calvingEventId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.deleteCalvingEvent = function (seasonId, calvingEventId, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).deleteCalvingEvent(seasonId, calvingEventId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete an existing heat event
     * @param {string} seasonId
     * @param {string} heatEventId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.deleteHeatEvent = function (seasonId, heatEventId, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).deleteHeatEvent(seasonId, heatEventId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete an existing season
     * @param {string} seasonId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.deleteSeason = function (seasonId, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).deleteSeason(seasonId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Find the active mating kpi warning based on the user\'s current datetime, relative to PSM and their current season metrics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.findActiveMatingKPIWarning = function (options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).findActiveMatingKPIWarning(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Find all seasons for a farm id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.findAllSeasons = function (options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).findAllSeasons(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Find cattle calving events
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find within the current season
     * @param {string} [cattleId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.findCalvingEvents = function (seasonId, cattleId, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).findCalvingEvents(seasonId, cattleId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Find mating length for a season
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.findFarmSeasonMatingLength = function (seasonId, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).findFarmSeasonMatingLength(seasonId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Find farm season metrics by metric type and seasonId
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {SeasonMetricTypeEnum} metricType Which metric to find values for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.findFarmSeasonMetrics = function (seasonId, metricType, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).findFarmSeasonMetrics(seasonId, metricType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Find metrics for forecasted in-calf rate for a season
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.findForecastedInCalfRateMetricData = function (seasonId, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).findForecastedInCalfRateMetricData(seasonId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Find metric graph for forecasted in-calf rate from the current date
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {Date} startDate The start date to display forecasted in-calf
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.findForecastedInCalfRateMetricGraph = function (seasonId, startDate, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).findForecastedInCalfRateMetricGraph(seasonId, startDate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Find cattle heat events
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {number} limit The maximum number of items to be returned
     * @param {string} [cattleId]
     * @param {Date} [firstDetectedAtBefore] If present, the results will be heat events with a firstDetectedAt earlier than this datetime
     * @param {Date} [firstDetectedAtAfter] If present, the results will be heat events with a firstDetectedAt later than this datetime
     * @param {Date} [overlappingDate] If present, just the cow heat events that have a firstDetectedAt within the \&#39;active\&#39; range of this value will be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.findHeatEvents = function (seasonId, limit, cattleId, firstDetectedAtBefore, firstDetectedAtAfter, overlappingDate, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).findHeatEvents(seasonId, limit, cattleId, firstDetectedAtBefore, firstDetectedAtAfter, overlappingDate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Find metrics for in calf for a season
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.findInCalfMetricData = function (seasonId, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).findInCalfMetricData(seasonId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Find metric graph, in-calf from PSM
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {Date} startDate The start date to display in-calf
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.findInCalfMetricGraph = function (seasonId, startDate, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).findInCalfMetricGraph(seasonId, startDate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Find metric data for a season
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {number} [daysSinceLastHeat] Defaults to 26, used to find cycling and non-cycling cows
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.findMetricData = function (seasonId, daysSinceLastHeat, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).findMetricData(seasonId, daysSinceLastHeat, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Find metric graph, cycling
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {Date} startDate The start date to display percent cycling
     * @param {Date} endDate The end date to display percent cycling
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.findMetricGraphCycling = function (seasonId, startDate, endDate, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).findMetricGraphCycling(seasonId, startDate, endDate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Find metric graph, day to first heat
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.findMetricGraphDaysToFirstHeat = function (seasonId, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).findMetricGraphDaysToFirstHeat(seasonId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Find metric graph, non-return
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {Date} startDate The start date to display non-return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.findMetricGraphNonReturn = function (seasonId, startDate, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).findMetricGraphNonReturn(seasonId, startDate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Find metric graph, on heat
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {Date} startDate The start date to display cow on heat
     * @param {Date} endDate The end date to display cow on heat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.findMetricGraphOnHeat = function (seasonId, startDate, endDate, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).findMetricGraphOnHeat(seasonId, startDate, endDate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Find metric graph, submission
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {Date} [endDate] The end date to display submitted percent, default of PSM + 12 weeks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.findMetricGraphSubmission = function (seasonId, endDate, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).findMetricGraphSubmission(seasonId, endDate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Find the previous equivalent season relative to the given season
     * @param {string} seasonId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.findPreviousEquivalentSeason = function (seasonId, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).findPreviousEquivalentSeason(seasonId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Find a season by id
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.findSeason = function (seasonId, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).findSeason(seasonId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {number} [radiusInKm] The radius around the given farm to search for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.findSeasonMetricsBenchmarks = function (seasonId, radiusInKm, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).findSeasonMetricsBenchmarks(seasonId, radiusInKm, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Find cattle for respective season metric
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {SeasonMetricsGroupEnum} seasonMetricGroup Returns cattle for the metric grouping
     * @param {number} limit the maximum number of items to be returned in this call
     * @param {number} offset paginate
     * @param {ISeasonMetricsRequestDTO} [iSeasonMetricsRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.findSeasonMetricsCattle = function (seasonId, seasonMetricGroup, limit, offset, iSeasonMetricsRequestDTO, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).findSeasonMetricsCattle(seasonId, seasonMetricGroup, limit, offset, iSeasonMetricsRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Find metric summary for a season
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {ISeasonMetricsRequestDTO} [iSeasonMetricsRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.findSeasonMetricsSummary = function (seasonId, iSeasonMetricsRequestDTO, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).findSeasonMetricsSummary(seasonId, iSeasonMetricsRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieve AB list for specified season
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.getABList = function (seasonId, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).getABList(seasonId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Breeding information for season for the passed cow
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {string} cattleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.getCowForSeason = function (seasonId, cattleId, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).getCowForSeason(seasonId, cattleId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get reproduction event summaries per cow for the whole farm
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {boolean} [getExcludedInSeason] Defaults to false if undefined, if true we return summaries for excluded cows
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.getCowReproductionSummaries = function (seasonId, getExcludedInSeason, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).getCowReproductionSummaries(seasonId, getExcludedInSeason, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Cow seasons for cattle in a farm.
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.getCowsForSeason = function (seasonId, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).getCowsForSeason(seasonId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Internal cron call to mark all old heat events with AB events \"in calf\".
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.resolveInseminationResultStatus = function (seasonId, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).resolveInseminationResultStatus(seasonId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update an existing calving event
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to update events in the current season
     * @param {string} calvingEventId
     * @param {IUpdateCowCalvingEventDTO} iUpdateCowCalvingEventDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.updateCalvingEvent = function (seasonId, calvingEventId, iUpdateCowCalvingEventDTO, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).updateCalvingEvent(seasonId, calvingEventId, iUpdateCowCalvingEventDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update if cattleIds are included or excluded in the season
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {IUpdateCowsIncludedInSeasonDTO} iUpdateCowsIncludedInSeasonDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.updateCowSeason = function (seasonId, iUpdateCowsIncludedInSeasonDTO, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).updateCowSeason(seasonId, iUpdateCowsIncludedInSeasonDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update an existing heat event
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to find the current season
     * @param {string} heatEventId
     * @param {IUpdateCowHeatEventDTO} iUpdateCowHeatEventDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.updateHeatEvent = function (seasonId, heatEventId, iUpdateCowHeatEventDTO, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).updateHeatEvent(seasonId, heatEventId, iUpdateCowHeatEventDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update an existing season
     * @param {string} seasonId This can be the season uuid, or \&#39;current\&#39; to update the current season
     * @param {IUpdateSeasonDTO} iUpdateSeasonDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    SeasonApi.prototype.updateSeason = function (seasonId, iUpdateSeasonDTO, options) {
        var _this = this;
        return (0, exports.SeasonApiFp)(this.configuration).updateSeason(seasonId, iUpdateSeasonDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SeasonApi;
}(base_1.BaseAPI));
exports.SeasonApi = SeasonApi;
